// import React, { useState, useEffect } from "react";
// import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
// import "leaflet/dist/leaflet.css";
// import L from "leaflet";
// import { FaRegHeart, FaHeart } from "react-icons/fa";
// import { BiRupee } from "react-icons/bi";
// import { AiOutlineInfo } from "react-icons/ai";
// import axios from "axios";
// import { useLocation } from "react-router-dom";
// import { Link } from "react-router-dom";
// import Slider from "react-slick";
// import { RiArrowDropDownLine } from "react-icons/ri";
// import { MdOutlineNavigateBefore, MdOutlineNavigateNext } from "react-icons/md";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faShareNodes, faUserCircle } from "@fortawesome/free-solid-svg-icons";
// import { AiOutlineUser } from "react-icons/ai";
// import { MdOutlineBedroomParent } from "react-icons/md";
// import { FaMapMarkerAlt } from "react-icons/fa";
// import { BiArea } from "react-icons/bi";
// import { FaRupeeSign } from "react-icons/fa";
// import { faChair } from "@fortawesome/free-solid-svg-icons";
// import { PiShareNetworkLight } from "react-icons/pi";
// import { PiCubeFocus } from "react-icons/pi";
// import { Heart } from "lucide-react";
// import { toast } from "react-toastify";
// import ShareModal from "../containers/ShareModal";
// import Login1 from "../auth/Login1";
// import SignUp1 from "../auth/SignUp1";
// import { useCity } from "./SearchContext";
// import { FaWhatsapp, FaPhone } from "react-icons/fa";
// import ContactDetails from "../containers/ContactDetails";

// const FeaturedDashboard = () => {
//   const [hoveredPropertyId, setHoveredPropertyId] = useState(null);
//   const [squareFtDropdownOpen, setSquareFtDropdownOpen] = useState(false);
//   const location = useLocation();
//   const propertytype = location.state?.propertyType;
//   const [properties, setProperties] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [search, setSearch] = useState("");
//   const [propertyType, setPropertyType] = useState("");
//   const [bhkType, setBhkType] = useState("");
//   const [furnishedStatus, setFurnishedStatus] = useState("");
//   const [minPrice, setMinPrice] = useState("");
//   const [maxPrice, setMaxPrice] = useState("");
//   const [minSquareFt, setMinSquareFt] = useState("");
//   const [maxSquareFt, setMaxSquareFt] = useState("");
//   const [filtersApplied, setFiltersApplied] = useState(false);
//   const [isFavorited, setIsFavorited] = useState(false);
//   const userId = sessionStorage.getItem("accessToken");
//   const [currentShareUrl, setCurrentShareUrl] = useState("");
//   const [activeShareId, setActiveShareId] = useState(null);
//   const [openShareModalAfterLogin, setOpenShareModalAfterLogin] =
//     useState(false);
//   const [isShareModalOpen, setIsShareModalOpen] = useState(false);
//   const { searchCity } = useCity();
//   const accessToken = sessionStorage.getItem("accessToken");
//   // Modal open states
//   const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
//   const [isSignUpModalOpen, setIsSignUpModalOpen] = useState(false);
//   const [activePropertyId, setActivePropertyId] = useState(null);
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [propertyImages, setPropertyImages] = useState([]);
//   const [totalPages, setTotalPages] = useState(1);
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 10;
//   const DEFAULT_CENTER = [18.5204, 73.8567];

//   const [postedBy, setPostedBy] = useState("");
//   const [constructionStatus, setConstructionStatus] = useState([]);
//   const [constructionOpen, setConstructionOpen] = useState(false);
//   const [amenitiesList, setAmenitiesList] = useState([]);
//   const [selectedAmenities, setSelectedAmenities] = useState([]);
//   const [amenitiesOpen, setAmenitiesOpen] = useState(false);
//   const [bathrooms, setBathrooms] = useState("");
//   const [facing, setFacing] = useState("");
//   const [withPhoto, setWithPhoto] = useState("");
//   const [withVideos, setWithVideos] = useState("");
//   const [areaIn, setAreaIn] = useState("sq.ft");
//   const [sharingType, setSharingType] = useState([]);
//   const [availableFrom, setAvailableFrom] = useState([]);

//   const [sharingTypeOpen, setSharingTypeOpen] = useState(false);
//   const [availableFromOpen, setAvailableFromOpen] = useState(false);
//   const [availableFor, setAvailableFor] = useState([]);
//   const [availableForOpen, setAvailableForOpen] = useState(false);
//   const [capacity, setCapacity] = useState([]);
//   const [capacityOpen, setCapacityOpen] = useState(false);
//   const [investmentOptions, setInvestmentOptions] = useState([]);
//   const [purchaseType, setPurchaseType] = useState("");
//   const [investmentOpen, setInvestmentOpen] = useState(false);

//   const [plotLandTypes, setPlotLandTypes] = useState([]);
//   const [plotLandOpen, setPlotLandOpen] = useState(false);

//   const [officeType, setOfficeType] = useState([]);
//   const [retailType, setRetailType] = useState([]);
//   const [otherCommercialType, setOtherCommercialType] = useState([]);

//   const [officeTypeOpen, setOfficeTypeOpen] = useState(false);
//   const [retailTypeOpen, setRetailTypeOpen] = useState(false);
//   const [otherCommercialOpen, setOtherCommercialOpen] = useState(false);

//   const [selectedProperty, setSelectedProperty] = useState(null);
//   const [isContactModalOpen, setIsContactModalOpen] = useState(false);
//   const [buildingType, setBuildingType] = useState("");
//   const [propertyType2, setPropertyType2] = useState([]);
//   const [propertyTypeOpen, setPropertyTypeOpen] = useState(false);
//   const [filterTrigger, setFilterTrigger] = useState(0);
//    const [freeViewCount, setFreeViewCount] = useState(0);
//   const [paidViewCount, setPaidViewCount] = useState(0);
//     const [showUpgradePrompt, setShowUpgradePrompt] = useState(false);


//   const officeTypeOptions = [
//     "Ready to move office space",
//     "Bare shell office space",
//     "Co-working office space",
//   ];

//   const retailTypeOptions = [
//     "Mall",
//     "Commercial Project",
//     "Residential Project",
//     "Retail Complex/Building",
//     "Market/High Street",
//   ];

//   const otherCommercialOptions = [
//     "Factory",
//     "Ware House",
//     "Hotel Resorts",
//     "Guest-House/Banquet-Halls",
//     "Cold Storage",
//     "Manufacturing",
//     "Others",
//   ];

//   const commercialPropertyOptions = [
//     "Ready to move office space",
//     "Bare shell office space",
//     "Ware House",
//     "Factory",
//     "Hotel/Resorts",
//     "Others",
//     "Plot/Land",
//     "Cold Storage",
//     "Manufacturing",
//     "Guest-House/Banquet-Halls",
//     "Retail", // important
//   ];

//   const plotLandOptions = [
//     "Commercial Land/Inst. Land",
//     "Industrial Lands/Plots",
//     "Agricultural/Farm Land",
//   ];

//   const investmentOptionsList = [
//     "Pre-leased Spaces",
//     "Restaurants",
//     "SCO Plots",
//     "Business Center",
//     "Food Court",
//     "Multiplex",
//     "Co-working",
//   ];

//   const purchaseTypeOptions = ["Resale", "New bookings"];

//   const priceOptions = [
//     500000, // 5 Lakh
//     1000000, // 10 Lakh
//     1500000, // 15 Lakh
//     2000000, // 20 Lakh
//     2500000, // 25 Lakh
//     3000000, // 30 Lakh
//     3500000, // 35 Lakh
//     4000000, // 40 Lakh
//     4500000, // 45 Lakh
//     5000000, // 50 Lakh
//     5500000, // 55 Lakh
//     6000000, // 60 Lakh
//     6500000, // 65 Lakh
//     7000000, // 70 Lakh
//     7500000, // 75 Lakh
//     8000000, // 80 Lakh
//     8500000, // 85 Lakh
//     9000000, // 90 Lakh
//     9500000, // 95 Lakh

//     10000000, // 1 Crore
//     12500000, // 1.25 Crore
//     15000000, // 1.5 Crore
//     17500000, // 1.75 Crore
//     20000000, // 2 Crore
//     25000000, // 2.5 Crore
//     30000000, // 3 Crore
//     40000000, // 4 Crore
//     50000000, // 5 Crore
//     75000000, // 7.5 Crore

//     100000000, // 10 Crore
//     150000000, // 15 Crore
//     200000000, // 20 Crore
//     250000000, // 25 Crore
//     300000000, // 30 Crore
//     400000000, // 40 Crore
//     500000000, // 50 Crore
//     600000000, // 60 Crore
//     700000000, // 70 Crore
//     750000000, // 75 Crore
//     900000000, // 90 Crore

//     1000000000, // 100 Crore
//     1500000000, // 150 Crore
//     2000000000, // 200 Crore
//     2500000000, // 250 Crore
//     3000000000, // 300 Crore
//     4000000000, // 400 Crore
//     5000000000, // 500 Crore
//     6000000000, // 600 Crore
//     7000000000, // 700 Crore
//     7500000000, // 750 Crore
//     9000000000, // 900 Crore

//     10000000000, // 1000 Crore (10 Billion)
//   ];

//   const areaUnits = [
//     "sq.ft",
//     "sq.yards",
//     "sq.m",
//     "acre",
//     "marla",
//     "cents",
//     "bigha",
//     "kottah",
//     "kanal",
//     "grounds",
//     "ares",
//     "biswa",
//     "guntha",
//     "aankadam",
//     "hectares",
//     "rood",
//     "chataks",
//     "perch",
//   ];

//   const getMapCenter = () => {
//     if (
//       properties.length > 0 &&
//       properties[0].latitude &&
//       properties[0].longitude
//     ) {
//       return [properties[0].latitude, properties[0].longitude];
//     }
//     return DEFAULT_CENTER;
//   };

//   const formatPriceMinMax = (value) => {
//     const num = Number(value);
//     if (num >= 10000000)
//       return (num / 10000000).toFixed(1).replace(/\.0$/, "") + " Cr";
//     if (num >= 100000)
//       return (num / 100000).toFixed(1).replace(/\.0$/, "") + " L";
//     if (num >= 1000) return (num / 1000).toFixed(1).replace(/\.0$/, "") + " K";
//     return num;
//   };

//   const toggleSquareFtDropdown = () => {
//     setSquareFtDropdownOpen((prev) => !prev);
//   };

//   const [priceDropdownOpen, setPriceDropdownOpen] = useState(false);

//   const togglePriceDropdown = () => {
//     setPriceDropdownOpen((prev) => !prev);
//   };

//   const handlePrev = () => {
//     setCurrentIndex((prev) =>
//       prev === 0 ? propertyImages.length - 1 : prev - 1,
//     );
//   };

//   const handleNext = () => {
//     setCurrentIndex((prev) =>
//       prev === propertyImages.length - 1 ? 0 : prev + 1,
//     );
//   };

//   const fetchAmenities = async () => {
//     try {
//       const formData = new FormData();

//       const response = await axios.post(
//         "https://api.nowaybroker.com/cust_api/get_amenities",
//         formData,
//       );

//       if (response.data.status === 1) {
//         setAmenitiesList(response.data.data);
//       }
//     } catch (error) {
//       console.log("Amenities fetch failed", error);
//     }
//   };

//   const toggleAmenity = (id) => {
//     const value = String(id);

//     setCurrentPage(1);

//     setSelectedAmenities((prev) =>
//       prev.includes(value)
//         ? prev.filter((item) => item !== value)
//         : [...prev, value],
//     );
//   };

//   const togglePropertyType = (type) => {
//     setCurrentPage(1);

//     setPropertyType2((prev) =>
//       prev.includes(type)
//         ? prev.filter((item) => item !== type)
//         : [...prev, type],
//     );
//   };

//   const incrementBathrooms = () => {
//     setCurrentPage(1);
//     setBathrooms((prev) => {
//       const current = parseInt(prev) || 0;
//       return current < 20 ? String(current + 1) : prev;
//     });
//   };

//   const decrementBathrooms = () => {
//     setCurrentPage(1);
//     setBathrooms((prev) => {
//       const current = parseInt(prev) || 0;
//       return current > 0 ? String(current - 1) : "";
//     });
//   };

//   const handleBathroomInput = (e) => {
//     const value = e.target.value;
//     setCurrentPage(1);
//     if (value === "") {
//       setBathrooms("");
//       return;
//     }

//     const numericValue = parseInt(value);

//     if (!isNaN(numericValue) && numericValue >= 0 && numericValue <= 20) {
//       setBathrooms(String(numericValue));
//     }
//   };

//   useEffect(() => {
//     fetchAmenities();
//   }, []);

//   useEffect(() => {
//     setError(null);
//     const style = document.createElement("style");
//     style.innerHTML = `
//       .leaflet-popup-content-wrapper {
//         margin-bottom: 50px !important;
//         padding: 0 !important;
//       }
      
//       .leaflet-popup-content {
//         margin: 0 !important;
//         padding: 0 !important;
//       }

//       .leaflet-container a.leaflet-popup-close-button {
//         z-index: 1000;
//         top: 5px !important;
//         left: 10px;
//         border: none;
//         background-color: rgba(0, 0, 0, 0.6);
//         color: white;
//         cursor: pointer;
//         border-radius: 50%;
//       }

//       .leaflet-container a.leaflet-popup-close-button:hover {
//         background-color: rgba(0, 0, 0, 0.9);
//         color: white;
//       }

//       .leaflet-container .leaflet-popup-heart-button {
//         z-index: 1000;
//         position: absolute;
//         top: 5px;
//         right: 10px; /* Adjust the position from right */
//         width: 26px;
//         height: 24px;
//         border: none;
//         background-color: rgba(0, 0, 0, 0.6);
//         color: white;
//         cursor: pointer;
//         border-radius: 20%;
//         display: flex;
//         align-items: center;
//         justify-content: center;
//         padding: 1px;
//       }

//       .leaflet-container .leaflet-popup-heart-button:hover {
//         background-color: rgba(0, 0, 0, 0.9);
//         color: white;
//       }
      
//       /* Wrapper for marker */
//       .marker-wrapper {
//         position: relative;
//         display: flex;
//         justify-content: center;
//         align-items: center;
//       }

//       .custom-marker.active .marker-wrapper .price-tooltip{
//          background-color: green;
//       }

//       /* Tooltip-like price box */
//       .price-tooltip {
//   background: white;
//   color: black; /* Ensure the text color is black */
//   padding: 8px 12px;
//   border-radius: 18px;
//   font-weight: bold; /* Make the text bold */
//   font-size: 1.1rem; /* Increased font size */
//   box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
//   position: relative;
//   text-align: center;
//   white-space: nowrap;
//   z-index: 10;
// }

//       .price-tooltip:hover {
//         background-color: gray; /* Change to gray on hover */
//         color: white; /* Optional: Change text color for better contrast */
//       }

//       /* Pointer (triangle below the box) */
//       .price-tooltip .pointer {
//         position: absolute;
//         bottom: -8px;
//         left: 50%;
//         transform: translateX(-50%);
//         width: 0;
//         height: 0;
//         border-left: 8px solid transparent;
//         border-right: 8px solid transparent;
//         border-top: 8px solid white;
//         background-color: lightgray;
//       }
      

//       /* Adjust the marker size */
//       .custom-marker {
//         display: flex;
//         align-items: center;
//         justify-content: center;
//       }
//       input[type="number"]::-webkit-outer-spin-button,
//       input[type="number"]::-webkit-inner-spin-button {
//         -webkit-appearance: none;
//         margin: 0;
//       }

//       input[type="number"] {
//         -moz-appearance: textfield;
//       }

//       .custom-button {
//         font-family: "Arial", sans-serif;
//         font-size: 1.5rem;
//         background-color: #fff;
//         padding: 0.5rem;
//         text-align: center;
//         cursor: pointer;
//       }

//       .custom-button:hover {
//         background-color: #f0f0f0;
//         color: #333;
//       }
//     `;
//     document.head.appendChild(style);
//   }, []);

//   const loadProperties = async () => {
//     setLoading(true);
//     setError(null);

//     try {
//       let response;

//       // =========================================
//       // FILTER API
//       // =========================================
//       if (filtersApplied) {
//         const formData = new FormData();

//         // =========================
//         // BASIC
//         // =========================
//         if (search) formData.append("area", search);

//         if (propertyType === "Commercial Buy") {
//           formData.append("property_category_type", "Buy");
//         } else if (propertyType === "Commercial Lease") {
//           formData.append("property_category_type", "Rent");
//         } else if (propertyType) {
//           formData.append("property_category_type", propertyType);
//         }
//         if (buildingType) {
//           formData.append("building_type", buildingType);
//         }

//         if (bhkType) {
//           formData.append("bhk_type", bhkType);
//         }

//         if (furnishedStatus) {
//           formData.append("furnished_type", furnishedStatus);
//         }

//         if (minPrice) {
//           formData.append("min_price", minPrice);
//         }

//         if (maxPrice) {
//           formData.append("max_price", maxPrice);
//         }

//         if (minSquareFt) {
//           formData.append("min_area", minSquareFt);
//         }

//         if (maxSquareFt) {
//           formData.append("max_area", maxSquareFt);
//         }

//         if ((minSquareFt || maxSquareFt) && areaIn) {
//           formData.append("area_in", areaIn);
//         }

//         if (searchCity) {
//           formData.append("city_name", searchCity);
//         }

//         // =========================
//         // POSTED BY
//         // =========================
//         if (postedBy) {
//           formData.append("user_type", postedBy);
//         }

//         // =========================
//         // CONSTRUCTION STATUS
//         // =========================
//         if (constructionStatus.length > 0) {
//           formData.append("construction_status", constructionStatus.join(","));
//         }

//         // =========================
//         // AMENITIES
//         // =========================
//         if (selectedAmenities.length > 0) {
//           formData.append("amenities", selectedAmenities.join(","));
//         }

//         // =========================
//         // BATHROOMS
//         // =========================
//         if (bathrooms) {
//           formData.append("no_of_bathrooms", bathrooms);
//         }

//         // =========================
//         // FACING
//         // =========================
//         if (facing) {
//           formData.append("facing", facing);
//         }

//         // =========================
//         // PHOTO / VIDEO
//         // =========================
//         if (withPhoto) {
//           formData.append("with_photo", withPhoto);
//         }

//         if (withVideos) {
//           formData.append("with_videos", withVideos);
//         }

//         // =========================
//         // AVAILABLE FOR
//         // =========================
//         if (availableFor.length > 0) {
//           formData.append("available_for", availableFor.join(","));
//         }

//         // =========================
//         // SHARING TYPE
//         // =========================
//         if (sharingType.length > 0) {
//           formData.append("sharing_type", sharingType.join(","));
//         }

//         // =========================
//         // AVAILABLE FROM
//         // =========================
//         if (availableFrom.length > 0) {
//           formData.append("available_from", availableFrom.join(","));
//         }

//         // =========================
//         // CAPACITY
//         // =========================
//         if (capacity.length > 0) {
//           formData.append("available_beds", mapCapacityToBeds(capacity));
//         }

//         // =========================
//         // INVESTMENT OPTIONS
//         // =========================
//         if (investmentOptions.length > 0) {
//           formData.append("investment_options", investmentOptions.join(","));
//         }

//         // =========================
//         // PURCHASE TYPE
//         // =========================
//         if (purchaseType) {
//           formData.append("purchase_type", purchaseType);
//         }

//         // =========================================
//         // COMMERCIAL BUY MAPPING
//         // =========================================
//         if (propertyType === "Commercial Buy") {
//           const mapped = mapCommercialTypes(propertyType2);

//           if (mapped.property_type.length > 0) {
//             formData.append("property_type", mapped.property_type.join(","));
//           }

//           if (mapped.office_type.length > 0) {
//             formData.append("office_type", mapped.office_type.join(","));
//           }

//           if (mapped.sub_sub_property_type.length > 0) {
//             formData.append(
//               "sub_sub_property_type",
//               mapped.sub_sub_property_type.join(","),
//             );
//           }
//         }

//         // =========================================
//         // COMMERCIAL LEASE MAPPING
//         // =========================================
//         else if (
//           propertyType === "Commercial Lease" &&
//           buildingType === "Commercial"
//         ) {
//           const mapped = mapCommercialLeaseTypes({
//             propertyType2,
//             officeType,
//             retailType,
//             otherCommercialType,
//             plotLandTypes,
//           });

//           if (mapped.property_type.length > 0) {
//             formData.append("property_type", mapped.property_type.join(","));
//           }

//           if (mapped.office_type.length > 0) {
//             formData.append("office_type", mapped.office_type.join(","));
//           }

//           if (mapped.sub_sub_property_type.length > 0) {
//             formData.append(
//               "sub_sub_property_type",
//               mapped.sub_sub_property_type.join(","),
//             );
//           }
//         }

//         // =========================================
//         // NORMAL PROPERTY TYPE
//         // =========================================
//         else {
//           if (propertyType2.length > 0) {
//             formData.append("property_type", propertyType2.join(","));
//           }
//         }

//         // =========================================
//         // COMMON
//         // =========================================
//         formData.append("customer_id", accessToken);
//         formData.append("page", currentPage);
//         formData.append("page_size", itemsPerPage);
//         formData.append("mark_as_featured", "Yes");

//         response = await axios.post(
//           `${process.env.REACT_APP_API_URL}/cust_api/filter_property`,
//           formData,
//           {
//             headers: {
//               "Content-Type": "multipart/form-data",
//             },
//           },
//         );
//       }

//       // =========================================
//       // DEFAULT FEATURED API
//       // =========================================
//       else {
//         response = await axios.post(
//           `${process.env.REACT_APP_API_URL}/cust_api/get_featured_property`,
//           {
//             user_id: userId,
//             property_category_type: propertytype,
//             page: currentPage,
//             page_size: itemsPerPage,
//             city_name: searchCity,
//           },
//         );
//       }

//       // =========================================
//       // RESPONSE
//       // =========================================
//       if (response.status === 200 && response.data.status === 1) {
//         setProperties(response.data.data || []);
//         setTotalPages(response.data.total_pages || 1);
//       } else {
//         setProperties([]);
//         setTotalPages(0);
//         setError("No properties available");
//       }
//     } catch (error) {
//       console.log("Load Properties Error:", error);

//       setProperties([]);
//       setTotalPages(0);
//       setError("Failed to load properties.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Fetch properties when dependencies change

//   useEffect(() => {
//     loadProperties();
//   }, [
//     searchCity,
//     userId,
//     currentPage,
//     filtersApplied,
//     propertytype,
//     filterTrigger,
//   ]);

//   useEffect(() => {
//     if (propertyType !== "Commercial Buy") {
//       setInvestmentOptions([]);
//       setPurchaseType("");
//     }

//     if (propertyType !== "PG/Co-living") {
//       setSharingType([]);
//       setCapacity([]);
//     }

//     if (propertyType !== "Rent") {
//       setAvailableFrom([]);
//     }
//   }, [propertyType]);

//   // Handle page change
//   const handlePageChange = (page) => {
//     if (page >= 1 && page <= totalPages) {
//       setCurrentPage(page);
//     }
//   };

//   // Pagination UI logic
//   const getPaginationRange = () => {
//     const range = [];
//     const groupSize = 3;

//     const groupStart =
//       Math.floor((currentPage - 1) / groupSize) * groupSize + 1;
//     const groupEnd = Math.min(groupStart + groupSize - 1, totalPages);

//     for (let i = groupStart; i <= groupEnd; i++) {
//       range.push(i);
//     }

//     if (groupEnd < totalPages) {
//       range.push("...");
//       range.push(totalPages);
//     }

//     return range;
//   };

//   const formatPrice = (price) => {
//     if (!price) return "";

//     price = parseInt(price);

//     const formatNumber = (num) => {
//       return num % 1 === 0 ? num.toFixed(0) : num.toFixed(2); // no decimals if whole number
//     };

//     if (price >= 10000000) {
//       return `₹ ${formatNumber(price / 10000000)} Cr`; // Crores
//     } else if (price >= 100000) {
//       return `₹ ${formatNumber(price / 100000)} L`; // Lakhs
//     } else if (price >= 1000) {
//       return `₹ ${formatNumber(price / 1000)} K`; // Thousands
//     } else {
//       return `₹ ${price}`;
//     }
//   };

//   const createCustomIcon = (property, isActive = false) => {
//     // Decide what to display
//     let displayValue = "";
//     if (property.property_category_type === "Buy" && property.property_price) {
//       displayValue = formatPrice(property.property_price);
//     } else if (property.property_category_type === "Rent" && property.rent) {
//       displayValue = formatPrice(property.rent);
//     }

//     return L.divIcon({
//       className: `custom-marker ${isActive ? "active" : ""}`,
//       html: `
//         <div class="marker-wrapper">
//           <div class="price-tooltip">
//             ${displayValue}
//             <div class="pointer"></div>
//           </div>
//         </div>
//       `,
//       iconSize: [50, 60],
//       iconAnchor: [25, 60],
//     });
//   };

//   const handleButtonClick = async () => {
//     setError(null);

//     if (filtersApplied) {
//       // RESET FILTERS
//       setSearch("");
//       setPropertyType("");
//       setBuildingType("");
//       setPropertyType2([]);

//       setBhkType("");
//       setFurnishedStatus("");

//       setMinPrice("");
//       setMaxPrice("");

//       setMinSquareFt("");
//       setMaxSquareFt("");

//       setPostedBy("");
//       setConstructionStatus([]);
//       setSelectedAmenities([]);

//       setBathrooms("");
//       setFacing("");

//       setWithPhoto("");
//       setWithVideos("");
//       setAreaIn("sq.ft");

//       setAvailableFor([]);
//       setSharingType([]);
//       setAvailableFrom([]);
//       setCapacity([]);

//       setInvestmentOptions([]);
//       setPurchaseType("");

//       setPlotLandTypes([]);
//       setOfficeType([]);
//       setRetailType([]);
//       setOtherCommercialType([]);

//       // CLOSE DROPDOWNS
//       // CLOSE DROPDOWNS
//       setPriceDropdownOpen(false);
//       setSquareFtDropdownOpen(false);

//       setAmenitiesOpen(false);
//       setConstructionOpen(false);

//       setPropertyTypeOpen(false);
//       setPlotLandOpen(false);

//       setOfficeTypeOpen(false);
//       setRetailTypeOpen(false);
//       setOtherCommercialOpen(false);

//       setAvailableForOpen(false);
//       setAvailableFromOpen(false);

//       setSharingTypeOpen(false);
//       setCapacityOpen(false);

//       setInvestmentOpen(false);

//       // IMPORTANT
//       setFiltersApplied(false);
//       setCurrentPage(1);
//       setFilterTrigger((prev) => prev + 1);
//     } else {
//       setFiltersApplied(true);
//       setCurrentPage(1);
//       setAreaIn("sq.ft");
//       setFilterTrigger((prev) => prev + 1);
//     }
//   };

//   //  Add to favorites
//   const addToFavorites = async (PropertyId) => {
//     if (!userId) {
//       alert("Please log in to save properties to your favorites.");
//       return;
//     }
//     try {
//       const response = await axios.post(
//         `${process.env.REACT_APP_API_URL}/cust_api/add_to_favorite`,
//         {
//           user_id: userId,
//           property_id: PropertyId,
//         },
//       );

//       loadProperties();
//     } catch (error) {
//       console.log("Failed to save the property. Please try again.");
//     }
//   };

//   // Remove from favorites
//   const removeFromFavorites = async (FavoriteId) => {
//     if (!userId) {
//       alert("Please log in to save properties to your favorites.");
//       return;
//     }

//     try {
//       await axios.delete(
//         `${process.env.REACT_APP_API_URL}/cust_api/remove_from_favorite`,
//         { data: { favorite_id: FavoriteId } },
//       );

//       loadProperties();
//     } catch (error) {
//       console.log("Failed to remove the property. Please try again.");
//     }
//   };

//   const toggleFavorite = async (propertyId) => {
//     const userId = sessionStorage.getItem("accessToken");
//     if (!userId) {
//       alert("Please log in to save properties to your favorites.");
//       return;
//     }

//     const data = { user_id: userId, property_id: propertyId };

//     try {
//       if (!isFavorited) {
//         await axios.post(
//           `${process.env.REACT_APP_API_URL}/cust_api/add_to_favorite`,
//           data,
//         );
//         setIsFavorited(true);
//         alert("Property has been saved to your favorites!");
//       } else {
//         await axios.post(
//           `${process.env.REACT_APP_API_URL}/cust_api/remove_from_favorite`,
//           data,
//         );
//         setIsFavorited(false);
//         alert("Property has been removed from your favorites!");
//       }
//     } catch (error) {
//       alert("Failed to update the property. Please try again.");
//     }
//   };

//   const handleSaveSearch = async () => {
//     if (!accessToken) {
//       toast.error("Please login first to save search.");
//       setIsLoginModalOpen(true);
//       return;
//     }

//     try {
//       const propertyIds = [];
//       const propertyNames = [];
//       const propertyCategories = [];
//       const buildingTypes = [];

//       properties.forEach((prop) => {
//         propertyIds.push(prop._id || "");
//         propertyNames.push(prop.property_name || "");
//         propertyCategories.push(prop.property_category_type || "");
//         buildingTypes.push(prop.building_type || "");
//       });

//       const formData = new FormData();

//       // =========================
//       // USER + PROPERTY
//       // =========================
//       formData.append("user_id", accessToken);
//       formData.append("property_id", propertyIds.join("|"));
//       formData.append("property_name", propertyNames.join("|"));
//       formData.append("property_category_type", propertyCategories.join("|"));
//       formData.append("building_type", buildingTypes.join("|"));

//       // =========================
//       // SEARCH INFO
//       // =========================
//       formData.append("city_name", searchCity || "");
//       formData.append("search_keyword", search || "");

//       // =========================
//       // COMMERCIAL MAPPING (CRITICAL)
//       // =========================
//       if (
//         propertyType === "Commercial Lease" &&
//         buildingType === "Commercial"
//       ) {
//         const mapped = mapCommercialLeaseTypes({
//           propertyType2,
//           officeType,
//           retailType,
//           otherCommercialType,
//           plotLandTypes,
//         });

//         if (mapped.property_type.length)
//           formData.append("property_type", mapped.property_type.join(","));

//         if (mapped.office_type.length)
//           formData.append("office_type", mapped.office_type.join(","));

//         if (mapped.sub_sub_property_type.length)
//           formData.append(
//             "sub_sub_property_type",
//             mapped.sub_sub_property_type.join(","),
//           );
//       } else if (propertyType === "Commercial Buy") {
//         const mapped = mapCommercialTypes(propertyType2);

//         if (mapped.property_type.length)
//           formData.append("property_type", mapped.property_type.join(","));

//         if (mapped.office_type.length)
//           formData.append("office_type", mapped.office_type.join(","));

//         if (mapped.sub_sub_property_type.length)
//           formData.append(
//             "sub_sub_property_type",
//             mapped.sub_sub_property_type.join(","),
//           );
//       } else {
//         if (propertyType2.length > 0) {
//           formData.append("property_type", propertyType2.join(","));
//         }
//       }

//       // =========================
//       // BASIC FILTERS
//       // =========================
//       if (bhkType) formData.append("bhk_type", bhkType);
//       if (furnishedStatus) formData.append("furnished_type", furnishedStatus);
//       if (minPrice) formData.append("min_price", minPrice);
//       if (maxPrice) formData.append("max_price", maxPrice);
//       if (minSquareFt) formData.append("min_area", minSquareFt);
//       if (maxSquareFt) formData.append("max_area", maxSquareFt);
//       if ((minSquareFt || maxSquareFt) && areaIn) {
//         formData.append("area_in", areaIn);
//       }
//       if (postedBy) formData.append("user_type", postedBy);

//       // =========================
//       // MULTI SELECT
//       // =========================
//       if (constructionStatus.length > 0) {
//         formData.append("construction_status", constructionStatus.join(","));
//       }

//       if (selectedAmenities.length > 0) {
//         formData.append("amenities", selectedAmenities.join(","));
//       }

//       // =========================
//       // EXTRA FILTERS
//       // =========================
//       if (bathrooms) formData.append("no_of_bathrooms", bathrooms);
//       if (facing) formData.append("facing", facing);
//       if (withPhoto) formData.append("with_photo", withPhoto);
//       if (withVideos) formData.append("with_videos", withVideos);

//       if (availableFor.length > 0) {
//         formData.append("available_for", availableFor.join(","));
//       }

//       if (sharingType.length > 0) {
//         formData.append("sharing_type", sharingType.join(","));
//       }

//       if (availableFrom.length > 0) {
//         formData.append("available_from", availableFrom.join(","));
//       }

//       if (capacity.length > 0) {
//         formData.append("available_beds", mapCapacityToBeds(capacity));
//       }

//       if (investmentOptions.length > 0) {
//         formData.append("investment_options", investmentOptions.join(","));
//       }

//       if (purchaseType) {
//         formData.append("purchase_type", purchaseType);
//       }

//       // =========================
//       // API CALL
//       // =========================
//       const response = await fetch(
//         `${process.env.REACT_APP_API_URL}/cust_api/add_save_search_property`,
//         {
//           method: "POST",
//           body: formData,
//         },
//       );

//       const result = await response.json();

//       if (response.ok && result.status === 1) {
//         toast.success("Search saved successfully!");
//       } else {
//         toast.error(result.message || "Failed to save search.");
//       }
//     } catch (error) {
//       console.error("Save Search Error:", error);
//       toast.error("Something went wrong.");
//     }
//   };

//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, []);

//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, [userId, currentPage]);

//   const [activeIndexes, setActiveIndexes] = useState({});

//   const openShareModal = (url, propertyId) => {
//     setCurrentShareUrl(url);
//     setActiveShareId(propertyId);
//     setIsShareModalOpen(true);
//   };

//   const handleCloseShareModal = () => {
//     setIsShareModalOpen(false);
//   };

//   const shouldShowFacingFilter = () => {
//     return propertyType2.includes("Plot/Land") || plotLandTypes.length > 0;
//   };

//   const getFilteredPropertyTypes = () => {
//     if (propertyType === "Commercial Lease" && buildingType === "Commercial") {
//       return [
//         "Office Space",
//         "Retail Shops/Showrooms",
//         "Other Commercial spaces",
//         "Plot/Land",
//       ];
//     }
//     if (propertyType === "Commercial Buy" || buildingType === "Commercial") {
//       return commercialPropertyOptions;
//     }

//     if (propertyType === "Buy") {
//       return [
//         "Flat/Apartment",
//         "Home/Villa",
//         "Service Apartment",
//         "Farmhouse",
//         "Plot/Land",
//         "Builder Floor",
//         "1RK/Studio Apartment",
//       ];
//     }

//     if (propertyType === "Rent") {
//       return [
//         "Flat/Apartment",
//         "Builder Floor",
//         "1RK/Studio Apartment",
//         "Independent House/Villa",
//         "Service Apartment",
//         "Farmhouse",
//       ];
//     }

//     if (propertyType === "PG/Co-living") {
//       return [
//         "Flat/Apartment",
//         "Builder Floor",
//         "1RK/Studio Apartment",
//         "Independent House/Villa",
//         "Service Apartment",
//       ];
//     }

//     // Default
//     return [
//       "Apartment",
//       "Flat/Apartment",
//       "Builder Floor",
//       "Independent House/Villa",
//       "Independent/Builder Floor",
//       "1RK/Studio Apartment",
//       "Service Apartment",
//       "Farmhouse",
//       "Office",
//       "Retail",
//       "Plot/Land",
//       "Storage",
//       "Industry",
//       "Hospitality",
//       "Other",
//       "Home/Villa",
//     ];
//   };

//   const toggleAvailableFor = (value) => {
//     setCurrentPage(1);

//     setAvailableFor((prev) =>
//       prev.includes(value)
//         ? prev.filter((item) => item !== value)
//         : [...prev, value],
//     );
//   };

//   const getAvailableForOptions = () => {
//     if (propertyType === "Rent") {
//       return ["Family", "Single Women", "Single Men", "Company Guest House"];
//     }

//     if (propertyType === "PG/Co-living") {
//       return ["Boys", "Girls", "Working"];
//     }

//     return [];
//   };

//   const toggleSharingType = (value) => {
//     setCurrentPage(1);

//     setSharingType((prev) =>
//       prev.includes(value)
//         ? prev.filter((item) => item !== value)
//         : [...prev, value],
//     );
//   };

//   const toggleAvailableFrom = (value) => {
//     setCurrentPage(1);

//     setAvailableFrom((prev) =>
//       prev.includes(value)
//         ? prev.filter((item) => item !== value)
//         : [...prev, value],
//     );
//   };
//   const toggleCapacity = (value) => {
//     setCurrentPage(1);

//     setCapacity((prev) =>
//       prev.includes(value)
//         ? prev.filter((item) => item !== value)
//         : [...prev, value],
//     );
//   };

//   const mapCapacityToBeds = (capacityArr) => {
//     const mapping = {
//       "1-2 guest": "1-2",
//       "2-4 guest": "2-4",
//       "4-10 guest": "4-10",
//       "10+ guest": "10+",
//     };

//     return capacityArr.map((item) => mapping[item]).join(",");
//   };

//   const toggleInvestmentOption = (value) => {
//     setCurrentPage(1);

//     setInvestmentOptions((prev) =>
//       prev.includes(value)
//         ? prev.filter((item) => item !== value)
//         : [...prev, value],
//     );
//   };

//   const togglePlotLandType = (value) => {
//     setCurrentPage(1);

//     setPlotLandTypes((prev) =>
//       prev.includes(value)
//         ? prev.filter((item) => item !== value)
//         : [...prev, value],
//     );
//   };

//   const toggleConstructionStatus = (value) => {
//     setCurrentPage(1);

//     setConstructionStatus((prev) =>
//       prev.includes(value)
//         ? prev.filter((item) => item !== value)
//         : [...prev, value],
//     );
//   };

//   useEffect(() => {
//     if (!propertyType2.includes("Plot/Land")) {
//       setPlotLandTypes([]);
//     }
//   }, [propertyType2]);

//   const mapCommercialTypes = (selectedTypes) => {
//     const property_type = [];
//     const office_type = [];
//     const sub_sub_property_type = [];

//     selectedTypes.forEach((item) => {
//       const val = item.trim();

//       if (val === "Plot/Land") {
//         property_type.push("Plot/Land");

//         if (plotLandTypes.length > 0) {
//           office_type.push(...plotLandTypes);
//         }
//       } else if (val === "Retail") {
//         property_type.push("Retail");
//       } else if (val === "Others") {
//         sub_sub_property_type.push("Others");
//       } else {
//         office_type.push(val);
//       }
//     });

//     return { property_type, office_type, sub_sub_property_type };
//   };

//   const mapCommercialLeaseTypes = ({
//     propertyType2,
//     officeType,
//     retailType,
//     otherCommercialType,
//     plotLandTypes,
//   }) => {
//     let property_type = [];
//     let office_type = [];
//     let sub_sub_property_type = [];

//     propertyType2.forEach((type) => {
//       //  OFFICE SPACE
//       if (type === "Office Space") {
//         property_type.push("Office");
//         office_type.push(...officeType);
//       }

//       //  RETAIL
//       else if (type === "Retail Shops/Showrooms") {
//         property_type.push("Retail");
//         sub_sub_property_type.push(...retailType);
//       }

//       //  OTHER COMMERCIAL
//       else if (type === "Other Commercial spaces") {
//         otherCommercialType.forEach((item) => {
//           if (item === "Others") {
//             sub_sub_property_type.push("Others");
//           } else {
//             office_type.push(item);
//           }
//         });
//       }

//       //  PLOT/LAND (same as before)
//       else if (type === "Plot/Land") {
//         property_type.push("Plot/Land");

//         // send plot sub-types in office_type (same as Buy logic)
//         if (plotLandTypes.length > 0) {
//           office_type.push(...plotLandTypes);
//         }
//       }
//     });

//     return {
//       property_type,
//       office_type,
//       sub_sub_property_type,
//       plotLandTypes,
//     };
//   };

//    const checkPostLimits = async () => {
//         try {
//           const profileForm = new FormData();
//           profileForm.append("user_id", accessToken);
    
//           const profileResponse = await axios.post(
//             `${process.env.REACT_APP_API_URL}/cust_api/get_profile`,
//             profileForm,
//             {
//               headers: {
//                 "Content-Type": "multipart/form-data",
//               },
//             },
//           );
    
//           const countData = profileResponse?.data?.count_data;
    
//           if (countData) {
//             setFreeViewCount(countData.free_view_count || 0);
//             setPaidViewCount(countData.paid_view_count || 0);
//           }
//         } catch (error) {
//           console.error("Error checking post limits:", error);
//         }
//       };
    
//       useEffect(() => {
//         if (accessToken) {
//           checkPostLimits();
//         }
//       }, [accessToken]);
    
//       const handleAddCount = async (updatedCount) => {
//         try {
//           const addCountFormData = new FormData();
    
//           if (freeViewCount > 0) {
//             addCountFormData.append("free_view_count", -1);
//           } else {
//             addCountFormData.append("paid_view_count", -1);
//           }
    
//           addCountFormData.append("user_id", accessToken);
    
//           const response = await fetch(
//             `${process.env.REACT_APP_API_URL}/cust_api/add_count`,
//             {
//               method: "POST",
//               body: addCountFormData,
//             },
//           );
    
//           const data = await response.json();
    
//           if (response.ok) {
//             checkPostLimits();
//           } else {
//             console.error("Failed to update count:", data.message);
//           }
//         } catch (error) {
//           console.error("API error:", error);
//         }
//       };
    
//       const handleContactClick = async (property) => {
//         if (!accessToken) {
//           setIsLoginModalOpen(true);
//           return;
//         }
    
//         setSelectedProperty(property);
    
//         // CASE 1 -> FREE VIEWS AVAILABLE
//         if (freeViewCount > 0) {
//           await handleAddCount(freeViewCount);
    
//           setShowUpgradePrompt(false);
//           setIsContactModalOpen(true);
//           return;
//         }
    
//         // CASE 2 -> PAID VIEWS AVAILABLE
//         if (paidViewCount > 0) {
//           await handleAddCount(paidViewCount);
    
//           setShowUpgradePrompt(false);
//           setIsContactModalOpen(true);
//           return;
//         }
    
//         // CASE 3 -> NO COUNTS LEFT
//         setShowUpgradePrompt(true);
//         setIsContactModalOpen(true);
//       };

//   return (
//     <>
//       <div className="flex flex-col p-1 space-y-4 sm:p-6 bg-rose-50 rounded-xl">
//         {/* Search and Filter Section */}
//         <div className="flex flex-col flex-wrap items-center justify-center gap-4 md:flex-row md:items-center">
//           {/* Left Side - Search Input (Optional Placeholder) */}

//           {/* Right Side Fields */}
//           <div className="flex flex-wrap w-full gap-2 mt-2 md:w-auto">
//             <div className="w-full sm:w-[200px]">
//               <select
//                 value={propertyType}
//                 onChange={(e) => {
//                   const val = e.target.value;

//                   setCurrentPage(1);
//                   setPropertyType(val);

//                   setPropertyType2([]);
//                   setOfficeType([]);
//                   setRetailType([]);
//                   setOtherCommercialType([]);
//                   setPlotLandTypes([]);
//                   setConstructionStatus([]);
//                   setSelectedAmenities([]);
//                   setAvailableFor([]);
//                   setSharingType([]);
//                   setAvailableFrom([]);
//                   setCapacity([]);

//                   if (val === "Commercial Buy") {
//                     setBuildingType("Commercial");
//                   } else if (val === "Commercial Lease") {
//                     setBuildingType("Commercial");
//                   } else {
//                     setBuildingType("");
//                   }
//                 }}
//                 className="w-full h-16 p-2 border-2 border-gray-300 rounded-md"
//               >
//                 <option value="">Property Category</option>
//                 <option value="Buy">Buy</option>
//                 <option value="Rent">Rent</option>
//                 <option value="Commercial Buy">Commercial Buy</option>
//                 <option value="Commercial Lease">Commercial Lease</option>
//                 <option value="PG/Co-living">PG/Co-living</option>
//               </select>
//             </div>

//             {/* Building Type Dropdown */}
//             <div className="w-full sm:w-[180px]">
//               <select
//                 value={buildingType}
//                 onChange={(e) => {
//                   setCurrentPage(1);
//                   setBuildingType(e.target.value);
//                 }}
//                 disabled={
//                   propertyType === "Commercial Buy" ||
//                   propertyType === "Commercial Lease"
//                 }
//                 className="w-full h-16 p-2 border-2 border-gray-300 rounded-md focus:outline-none hover:bg-gray-300"
//               >
//                 <option value="">Building Type</option>
//                 <option value="Commercial">Commercial</option>
//                 <option value="Residential">Residential</option>
//               </select>
//             </div>

//             <div className="relative w-full sm:w-[260px]">
//               <button
//                 type="button"
//                 onClick={() => setPropertyTypeOpen(!propertyTypeOpen)}
//                 className="flex items-center justify-between w-full h-16 px-4 bg-white border-2 border-gray-300 rounded-md"
//               >
//                 <span className="truncate text-left">
//                   {propertyType2.length > 0
//                     ? propertyType2.join(", ")
//                     : "Property Type"}
//                 </span>

//                 <RiArrowDropDownLine className="text-2xl" />
//               </button>

//               {propertyTypeOpen && (
//                 <div className="absolute left-0 z-50 w-full mt-2 bg-white border rounded-md shadow-lg max-h-72 overflow-y-auto">
//                   {getFilteredPropertyTypes().map((type) => (
//                     <label
//                       key={type}
//                       className="flex items-center gap-3 px-3 py-2 cursor-pointer hover:bg-gray-100"
//                     >
//                       <input
//                         type="checkbox"
//                         name="propertyType"
//                         checked={propertyType2.includes(type)}
//                         onChange={() => togglePropertyType(type)}
//                       />

//                       <span>{type}</span>
//                     </label>
//                   ))}

//                   <div className="sticky bottom-0 flex gap-2 p-2 bg-white border-t">
//                     <button
//                       onClick={() => setPropertyType2([])}
//                       className="w-1/2 py-2 border rounded-md"
//                     >
//                       Clear
//                     </button>

//                     <button
//                       onClick={() => setPropertyTypeOpen(false)}
//                       className="w-1/2 py-2 text-white bg-rose-500 rounded-md"
//                     >
//                       Done
//                     </button>
//                   </div>
//                 </div>
//               )}
//             </div>

//             {/* Budget Dropdown */}
//             <div className="relative w-full sm:w-48 md:w-60">
//               <button
//                 onClick={togglePriceDropdown}
//                 className="flex items-center justify-between w-full h-16 px-4 bg-white border-2 border-gray-300 rounded-md focus:outline-none hover:bg-gray-300"
//               >
//                 <span>
//                   {minPrice && maxPrice
//                     ? `${formatPriceMinMax(minPrice)} - ${formatPriceMinMax(maxPrice)}`
//                     : minPrice
//                       ? `Above ${formatPriceMinMax(minPrice)}`
//                       : maxPrice
//                         ? `Below ${formatPriceMinMax(maxPrice)}`
//                         : "Budget"}
//                 </span>

//                 <RiArrowDropDownLine className="text-2xl" />
//               </button>

//               {priceDropdownOpen && (
//                 <div className="absolute left-0 mt-2 w-full p-4 bg-white border-2 border-gray-300 rounded-md shadow-lg z-[20]">
//                   <div className="flex flex-col gap-2">
//                     <label className="text-sm text-gray-600">Min Price</label>
//                     <select
//                       value={minPrice}
//                       onChange={(e) => {
//                         setCurrentPage(1);
//                         setMinPrice(e.target.value);
//                       }}
//                       className="p-2 border-2 border-gray-300 rounded-md focus:outline-none"
//                     >
//                       <option value="">Min</option>
//                       {priceOptions
//                         .filter((price) => !maxPrice || price < maxPrice) // enforce < Max
//                         .map((price) => (
//                           <option key={price} value={price}>
//                             {formatPriceMinMax(price)}
//                           </option>
//                         ))}
//                     </select>

//                     <label className="text-sm text-gray-600">Max Price</label>
//                     <select
//                       value={maxPrice}
//                       onChange={(e) => {
//                         setCurrentPage(1);
//                         setMaxPrice(e.target.value);
//                       }}
//                       className="p-2 border-2 border-gray-300 rounded-md focus:outline-none"
//                     >
//                       <option value="">Max</option>
//                       {priceOptions
//                         .filter((price) => !minPrice || price > minPrice) // enforce > Min
//                         .map((price) => (
//                           <option key={price} value={price}>
//                             {formatPriceMinMax(price)}
//                           </option>
//                         ))}
//                     </select>
//                   </div>
//                 </div>
//               )}
//             </div>

//             {/* Furnished Status Dropdown */}
//             <div className="w-full sm:w-[200px]">
//               <select
//                 value={furnishedStatus}
//                 onChange={(e) => {
//                   setCurrentPage(1);
//                   setFurnishedStatus(e.target.value);
//                 }}
//                 className="w-full h-16 p-2 border-2 border-gray-300 rounded-md focus:outline-none hover:bg-gray-300"
//               >
//                 <option value="">Select Furnished</option>
//                 <option value="Furnished">Furnished</option>
//                 <option value="Semi-Furnished">Semi-Furnished</option>
//                 <option value="Unfurnished">Unfurnished</option>
//               </select>
//             </div>

//             {/* BHK Type Dropdown */}
//             <div className="w-full sm:w-[150px]">
//               <select
//                 value={bhkType}
//                 onChange={(e) => {
//                   setCurrentPage(1);
//                   setBhkType(e.target.value);
//                 }}
//                 className="w-full h-16 p-2 border-2 border-gray-300 rounded-md focus:outline-none hover:bg-gray-300"
//               >
//                 <option value="">Select BHK</option>
//                 <option value="Studio">Studio</option>
//                 <option value="1 RK">1 RK</option>
//                 <option value="1 BHK">1 BHK</option>
//                 <option value="1.5 BHK">1.5 BHK</option>
//                 <option value="2 BHK">2 BHK</option>
//                 <option value="2.5 BHK">2.5 BHK</option>
//                 <option value="3 BHK">3 BHK</option>
//                 <option value="3.5 BHK">3.5 BHK</option>
//                 <option value="4 BHK">4 BHK</option>
//                 <option value="5 BHK">5 BHK</option>
//                 <option value="6+ BHK">6+ BHK</option>
//               </select>
//             </div>

//             {/* Posted By Dropdown */}
//             <div className="w-full sm:w-[180px]">
//               <select
//                 value={postedBy}
//                 onChange={(e) => {
//                   setCurrentPage(1);
//                   setPostedBy(e.target.value);
//                 }}
//                 className="w-full h-16 p-2 border-2 border-gray-300 rounded-md focus:outline-none hover:bg-gray-300"
//               >
//                 <option value="">Posted By</option>
//                 <option value="Owner">Owner</option>
//                 <option value="Builder">Builder</option>
//               </select>
//             </div>

//             {/* Construction Status */}
//             <div className="relative w-full sm:w-[260px]">
//               <button
//                 type="button"
//                 onClick={() => setConstructionOpen(!constructionOpen)}
//                 className="flex items-center justify-between w-full h-16 px-4 bg-white border-2 border-gray-300 rounded-md"
//               >
//                 <span className="truncate text-left">
//                   {constructionStatus.length > 0
//                     ? constructionStatus.join(", ")
//                     : "Construction Status"}
//                 </span>

//                 <RiArrowDropDownLine className="text-2xl" />
//               </button>

//               {constructionOpen && (
//                 <div className="absolute left-0 z-50 w-full mt-2 bg-white border rounded-md shadow-lg">
//                   {["Ready To Move", "New Launch", "Under Construction"].map(
//                     (option) => (
//                       <label
//                         key={option}
//                         className="flex items-center gap-3 px-3 py-2 cursor-pointer hover:bg-gray-100"
//                       >
//                         <input
//                           type="checkbox"
//                           checked={constructionStatus.includes(option)}
//                           onChange={() => toggleConstructionStatus(option)}
//                         />
//                         <span>{option}</span>
//                       </label>
//                     ),
//                   )}

//                   <div className="sticky bottom-0 flex gap-2 p-2 bg-white border-t">
//                     <button
//                       onClick={() => setConstructionStatus([])}
//                       className="w-1/2 py-2 border rounded-md"
//                     >
//                       Clear
//                     </button>

//                     <button
//                       onClick={() => setConstructionOpen(false)}
//                       className="w-1/2 py-2 text-white bg-rose-500 rounded-md"
//                     >
//                       Done
//                     </button>
//                   </div>
//                 </div>
//               )}
//             </div>

//             <div className="relative w-full sm:w-[260px]">
//               <button
//                 type="button"
//                 onClick={() => setAmenitiesOpen(!amenitiesOpen)}
//                 className="flex items-center justify-between w-full h-16 px-4 bg-white border-2 border-gray-300 rounded-md"
//               >
//                 <span className="truncate text-left">
//                   {selectedAmenities.length > 0
//                     ? amenitiesList
//                         .filter((item) =>
//                           selectedAmenities.includes(String(item._id)),
//                         )
//                         .map((item) => item.amenity_name)
//                         .join(", ")
//                     : "Amenities"}
//                 </span>

//                 <RiArrowDropDownLine className="text-2xl" />
//               </button>

//               {amenitiesOpen && (
//                 <div className="absolute left-0 z-50 w-full mt-2 bg-white border rounded-md shadow-lg max-h-72 overflow-y-auto">
//                   {amenitiesList.map((item) => (
//                     <label
//                       key={item._id}
//                       className="flex items-center gap-3 px-3 py-2 cursor-pointer hover:bg-gray-100"
//                     >
//                       <input
//                         type="checkbox"
//                         checked={selectedAmenities.includes(String(item._id))}
//                         onChange={() => toggleAmenity(item._id)}
//                       />

//                       <span>{item.amenity_name}</span>
//                     </label>
//                   ))}

//                   <div className="sticky bottom-0 flex gap-2 p-2 bg-white border-t">
//                     <button
//                       onClick={() => setSelectedAmenities([])}
//                       className="w-1/2 py-2 border rounded-md"
//                     >
//                       Clear
//                     </button>

//                     <button
//                       onClick={() => setAmenitiesOpen(false)}
//                       className="w-1/2 py-2 text-white bg-rose-500 rounded-md"
//                     >
//                       Done
//                     </button>
//                   </div>
//                 </div>
//               )}
//             </div>

//             <div className="w-full sm:w-[180px]">
//               <div className="flex items-center h-16 overflow-hidden bg-white border-2 border-gray-300 rounded-md">
//                 <button
//                   type="button"
//                   onClick={decrementBathrooms}
//                   className="flex items-center justify-center w-14 h-full text-2xl font-bold border-r hover:bg-gray-200"
//                 >
//                   -
//                 </button>

//                 <input
//                   type="number"
//                   min="0"
//                   max="20"
//                   value={bathrooms}
//                   onChange={handleBathroomInput}
//                   placeholder="Bathrooms"
//                   className="w-full h-full text-center focus:outline-none"
//                 />

//                 <button
//                   type="button"
//                   onClick={incrementBathrooms}
//                   className="flex items-center justify-center w-14 h-full text-2xl font-bold border-l hover:bg-gray-200"
//                 >
//                   +
//                 </button>
//               </div>
//             </div>

//             {shouldShowFacingFilter() && (
//               <div className="w-full sm:w-[200px]">
//                 <select
//                   value={facing}
//                   onChange={(e) => {
//                     setCurrentPage(1);
//                     setFacing(e.target.value);
//                   }}
//                   className="w-full h-16 p-2 border-2 border-gray-300 rounded-md focus:outline-none hover:bg-gray-300"
//                 >
//                   <option value="">Facing</option>
//                   <option value="North">North</option>
//                   <option value="East">East</option>
//                   <option value="North-East">North-East</option>
//                   <option value="South-East">South-East</option>
//                   <option value="North-West">North-West</option>
//                   <option value="West">West</option>
//                   <option value="South">South</option>
//                   <option value="South-West">South-West</option>
//                 </select>
//               </div>
//             )}

//             <div className="w-full sm:w-[180px]">
//               <select
//                 value={withPhoto}
//                 onChange={(e) => {
//                   setCurrentPage(1);
//                   setWithPhoto(e.target.value);
//                 }}
//                 className="w-full h-16 p-2 border-2 border-gray-300 rounded-md focus:outline-none hover:bg-gray-300"
//               >
//                 <option value="">With Photo</option>
//                 <option value="Yes">Yes</option>
//                 <option value="No">No</option>
//               </select>
//             </div>

//             <div className="w-full sm:w-[180px]">
//               <select
//                 value={withVideos}
//                 onChange={(e) => {
//                   setCurrentPage(1);
//                   setWithVideos(e.target.value);
//                 }}
//                 className="w-full h-16 p-2 border-2 border-gray-300 rounded-md focus:outline-none hover:bg-gray-300"
//               >
//                 <option value="">With Video</option>
//                 <option value="Yes">Yes</option>
//                 <option value="No">No</option>
//               </select>
//             </div>

//             {/* Sq. Ft Range Dropdown */}
//             <div className="relative w-full sm:w-[240px]">
//               <button
//                 onClick={toggleSquareFtDropdown}
//                 className="flex items-center justify-between w-full h-16 p-2 bg-white border-2 border-gray-300 rounded-md focus:outline-none hover:bg-gray-300"
//               >
//                 <span>
//                   {minSquareFt || maxSquareFt
//                     ? `${minSquareFt || 0} - ${maxSquareFt || "Any"} ${areaIn}`
//                     : "Area"}
//                 </span>

//                 <RiArrowDropDownLine className="text-2xl" />
//               </button>

//               {squareFtDropdownOpen && (
//                 <div className="absolute left-0 mt-2 w-full p-4 bg-white border-2 border-gray-300 rounded-md shadow-lg z-[20]">
//                   {/* Area Unit */}
//                   <label className="text-sm text-gray-600">Area Unit</label>
//                   <select
//                     value={areaIn}
//                     onChange={(e) => {
//                       setCurrentPage(1);
//                       setAreaIn(e.target.value);
//                     }}
//                     className="w-full p-2 mb-3 border-2 border-gray-300 rounded-md focus:outline-none"
//                   >
//                     {areaUnits.map((unit) => (
//                       <option key={unit} value={unit}>
//                         {unit}
//                       </option>
//                     ))}
//                   </select>

//                   {/* Min Area */}
//                   <label className="text-sm text-gray-600">Min Area</label>
//                   <input
//                     type="number"
//                     value={minSquareFt}
//                     onChange={(e) => {
//                       setCurrentPage(1);
//                       setMinSquareFt(e.target.value);
//                     }}
//                     className="w-full p-2 mb-3 border-2 border-gray-300 rounded-md focus:outline-none"
//                     placeholder="Min"
//                   />

//                   {/* Max Area */}
//                   <label className="text-sm text-gray-600">Max Area</label>
//                   <input
//                     type="number"
//                     value={maxSquareFt}
//                     onChange={(e) => {
//                       setCurrentPage(1);
//                       setMaxSquareFt(e.target.value);
//                     }}
//                     className="w-full p-2 border-2 border-gray-300 rounded-md focus:outline-none"
//                     placeholder="Max"
//                   />
//                 </div>
//               )}
//             </div>

//             {propertyType === "PG/Co-living" && (
//               <div className="relative w-full sm:w-[260px]">
//                 <button
//                   type="button"
//                   onClick={() => setSharingTypeOpen(!sharingTypeOpen)}
//                   className="flex items-center justify-between w-full h-16 px-4 bg-white border-2 border-gray-300 rounded-md"
//                 >
//                   <span className="truncate text-left">
//                     {sharingType.length > 0
//                       ? sharingType.join(", ")
//                       : "Sharing Type"}
//                   </span>

//                   <RiArrowDropDownLine className="text-2xl" />
//                 </button>

//                 {sharingTypeOpen && (
//                   <div className="absolute left-0 z-50 w-full mt-2 bg-white border rounded-md shadow-lg">
//                     {[
//                       "Private Rooms",
//                       "2 Per Room",
//                       "More than 2 per room",
//                     ].map((option) => (
//                       <label
//                         key={option}
//                         className="flex items-center gap-3 px-3 py-2 cursor-pointer hover:bg-gray-100"
//                       >
//                         <input
//                           type="checkbox"
//                           checked={sharingType.includes(option)}
//                           onChange={() => toggleSharingType(option)}
//                         />
//                         <span>{option}</span>
//                       </label>
//                     ))}

//                     <div className="sticky bottom-0 flex gap-2 p-2 bg-white border-t">
//                       <button
//                         onClick={() => setSharingType([])}
//                         className="w-1/2 py-2 border rounded-md"
//                       >
//                         Clear
//                       </button>

//                       <button
//                         onClick={() => setSharingTypeOpen(false)}
//                         className="w-1/2 py-2 text-white bg-rose-500 rounded-md"
//                       >
//                         Done
//                       </button>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             )}

//             {propertyType === "Rent" && (
//               <div className="relative w-full sm:w-[260px]">
//                 <button
//                   type="button"
//                   onClick={() => setAvailableFromOpen(!availableFromOpen)}
//                   className="flex items-center justify-between w-full h-16 px-4 bg-white border-2 border-gray-300 rounded-md"
//                 >
//                   <span className="truncate text-left">
//                     {availableFrom.length > 0
//                       ? availableFrom.join(", ")
//                       : "Available From"}
//                   </span>

//                   <RiArrowDropDownLine className="text-2xl" />
//                 </button>

//                 {availableFromOpen && (
//                   <div className="absolute left-0 z-50 w-full mt-2 bg-white border rounded-md shadow-lg">
//                     {[
//                       "Immediately",
//                       "Any Time",
//                       "Within 1 Month",
//                       "After 1 Month",
//                       "Within 3 Month",
//                       "After 3 Month",
//                     ].map((option) => (
//                       <label
//                         key={option}
//                         className="flex items-center gap-3 px-3 py-2 cursor-pointer hover:bg-gray-100"
//                       >
//                         <input
//                           type="checkbox"
//                           checked={availableFrom.includes(option)}
//                           onChange={() => toggleAvailableFrom(option)}
//                         />
//                         <span>{option}</span>
//                       </label>
//                     ))}

//                     <div className="sticky bottom-0 flex gap-2 p-2 bg-white border-t">
//                       <button
//                         onClick={() => setAvailableFrom([])}
//                         className="w-1/2 py-2 border rounded-md"
//                       >
//                         Clear
//                       </button>

//                       <button
//                         onClick={() => setAvailableFromOpen(false)}
//                         className="w-1/2 py-2 text-white bg-rose-500 rounded-md"
//                       >
//                         Done
//                       </button>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             )}

//             {(propertyType === "Rent" || propertyType === "PG/Co-living") && (
//               <div className="relative w-full sm:w-[260px]">
//                 <button
//                   type="button"
//                   onClick={() => setAvailableForOpen(!availableForOpen)}
//                   className="flex items-center justify-between w-full h-16 px-4 bg-white border-2 border-gray-300 rounded-md"
//                 >
//                   <span className="truncate text-left">
//                     {availableFor.length > 0
//                       ? availableFor.join(", ")
//                       : "Available For"}
//                   </span>

//                   <RiArrowDropDownLine className="text-2xl" />
//                 </button>

//                 {availableForOpen && (
//                   <div className="absolute left-0 z-50 w-full mt-2 bg-white border rounded-md shadow-lg max-h-72 overflow-y-auto">
//                     {getAvailableForOptions().map((option) => (
//                       <label
//                         key={option}
//                         className="flex items-center gap-3 px-3 py-2 cursor-pointer hover:bg-gray-100"
//                       >
//                         <input
//                           type="checkbox"
//                           checked={availableFor.includes(option)}
//                           onChange={() => toggleAvailableFor(option)}
//                         />
//                         <span>{option}</span>
//                       </label>
//                     ))}

//                     <div className="sticky bottom-0 flex gap-2 p-2 bg-white border-t">
//                       <button
//                         onClick={() => setAvailableFor([])}
//                         className="w-1/2 py-2 border rounded-md"
//                       >
//                         Clear
//                       </button>

//                       <button
//                         onClick={() => setAvailableForOpen(false)}
//                         className="w-1/2 py-2 text-white bg-rose-500 rounded-md"
//                       >
//                         Done
//                       </button>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             )}

//             {propertyType === "PG/Co-living" && (
//               <div className="relative w-full sm:w-[260px]">
//                 <button
//                   type="button"
//                   onClick={() => setCapacityOpen(!capacityOpen)}
//                   className="flex items-center justify-between w-full h-16 px-4 bg-white border-2 border-gray-300 rounded-md"
//                 >
//                   <span className="truncate text-left">
//                     {capacity.length > 0
//                       ? capacity.join(", ")
//                       : "Total Capacity"}
//                   </span>

//                   <RiArrowDropDownLine className="text-2xl" />
//                 </button>

//                 {capacityOpen && (
//                   <div className="absolute left-0 z-50 w-full mt-2 bg-white border rounded-md shadow-lg">
//                     {["1-2 guest", "2-4 guest", "4-10 guest", "10+ guest"].map(
//                       (option) => (
//                         <label
//                           key={option}
//                           className="flex items-center gap-3 px-3 py-2 cursor-pointer hover:bg-gray-100"
//                         >
//                           <input
//                             type="checkbox"
//                             checked={capacity.includes(option)}
//                             onChange={() => toggleCapacity(option)}
//                           />
//                           <span>{option}</span>
//                         </label>
//                       ),
//                     )}

//                     <div className="sticky bottom-0 flex gap-2 p-2 bg-white border-t">
//                       <button
//                         onClick={() => setCapacity([])}
//                         className="w-1/2 py-2 border rounded-md"
//                       >
//                         Clear
//                       </button>

//                       <button
//                         onClick={() => setCapacityOpen(false)}
//                         className="w-1/2 py-2 text-white bg-rose-500 rounded-md"
//                       >
//                         Done
//                       </button>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             )}

//             {propertyType === "Commercial Buy" && (
//               <div className="relative w-full sm:w-[260px]">
//                 <button
//                   type="button"
//                   onClick={() => setInvestmentOpen(!investmentOpen)}
//                   className="flex items-center justify-between w-full h-16 px-4 bg-white border-2 border-gray-300 rounded-md"
//                 >
//                   <span className="truncate text-left">
//                     {investmentOptions.length > 0
//                       ? investmentOptions.join(", ")
//                       : "Investment Options"}
//                   </span>
//                   <RiArrowDropDownLine className="text-2xl" />
//                 </button>

//                 {investmentOpen && (
//                   <div className="absolute left-0 z-50 w-full mt-2 bg-white border rounded-md shadow-lg">
//                     {investmentOptionsList.map((option) => (
//                       <label
//                         key={option}
//                         className="flex items-center gap-3 px-3 py-2 cursor-pointer hover:bg-gray-100"
//                       >
//                         <input
//                           type="checkbox"
//                           checked={investmentOptions.includes(option)}
//                           onChange={() => toggleInvestmentOption(option)}
//                         />
//                         <span>{option}</span>
//                       </label>
//                     ))}

//                     <div className="sticky bottom-0 flex gap-2 p-2 bg-white border-t">
//                       <button
//                         onClick={() => setInvestmentOptions([])}
//                         className="w-1/2 py-2 border rounded-md"
//                       >
//                         Clear
//                       </button>

//                       <button
//                         onClick={() => setInvestmentOpen(false)}
//                         className="w-1/2 py-2 text-white bg-rose-500 rounded-md"
//                       >
//                         Done
//                       </button>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             )}

//             {propertyType === "Commercial Buy" && (
//               <div className="w-full sm:w-[200px]">
//                 <select
//                   value={purchaseType}
//                   onChange={(e) => {
//                     setCurrentPage(1);
//                     setPurchaseType(e.target.value);
//                   }}
//                   className="w-full h-16 p-2 border-2 border-gray-300 rounded-md focus:outline-none hover:bg-gray-300"
//                 >
//                   <option value="">Purchase Type</option>
//                   {purchaseTypeOptions.map((option) => (
//                     <option key={option} value={option}>
//                       {option}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             )}

//             {(propertyType === "Commercial Buy" ||
//               propertyType === "Commercial Lease") &&
//               buildingType === "Commercial" &&
//               propertyType2.includes("Plot/Land") && (
//                 <div className="relative w-full sm:w-[260px]">
//                   <button
//                     type="button"
//                     onClick={() => setPlotLandOpen(!plotLandOpen)}
//                     className="flex items-center justify-between w-full h-16 px-4 bg-white border-2 border-gray-300 rounded-md"
//                   >
//                     <span className="truncate text-left">
//                       {plotLandTypes.length > 0
//                         ? plotLandTypes.join(", ")
//                         : "Plot/Land Type"}
//                     </span>
//                     <RiArrowDropDownLine className="text-2xl" />
//                   </button>

//                   {plotLandOpen && (
//                     <div className="absolute left-0 z-50 w-full mt-2 bg-white border rounded-md shadow-lg">
//                       {plotLandOptions.map((option) => (
//                         <label
//                           key={option}
//                           className="flex items-center gap-3 px-3 py-2 cursor-pointer hover:bg-gray-100"
//                         >
//                           <input
//                             type="checkbox"
//                             checked={plotLandTypes.includes(option)}
//                             onChange={() => togglePlotLandType(option)}
//                           />
//                           <span>{option}</span>
//                         </label>
//                       ))}

//                       <div className="sticky bottom-0 flex gap-2 p-2 bg-white border-t">
//                         <button
//                           onClick={() => setPlotLandTypes([])}
//                           className="w-1/2 py-2 border rounded-md"
//                         >
//                           Clear
//                         </button>

//                         <button
//                           onClick={() => setPlotLandOpen(false)}
//                           className="w-1/2 py-2 text-white bg-rose-500 rounded-md"
//                         >
//                           Done
//                         </button>
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               )}

//             {propertyType === "Commercial Lease" &&
//               buildingType === "Commercial" &&
//               propertyType2.includes("Office Space") && (
//                 <div className="relative w-full sm:w-[260px]">
//                   <button
//                     type="button"
//                     onClick={() => setOfficeTypeOpen(!officeTypeOpen)}
//                     className="flex items-center justify-between w-full h-16 px-4 bg-white border-2 border-gray-300 rounded-md"
//                   >
//                     <span className="truncate text-left">
//                       {officeType.length > 0
//                         ? officeType.join(", ")
//                         : "Office Type"}
//                     </span>
//                     <RiArrowDropDownLine className="text-2xl" />
//                   </button>

//                   {officeTypeOpen && (
//                     <div className="absolute left-0 z-50 w-full mt-2 bg-white border rounded-md shadow-lg">
//                       {officeTypeOptions.map((option) => (
//                         <label
//                           key={option}
//                           className="flex items-center gap-3 px-3 py-2"
//                         >
//                           <input
//                             type="checkbox"
//                             checked={officeType.includes(option)}
//                             onChange={() => {
//                               setCurrentPage(1);
//                               setOfficeType((prev) =>
//                                 prev.includes(option)
//                                   ? prev.filter((i) => i !== option)
//                                   : [...prev, option],
//                               );
//                             }}
//                           />
//                           <span>{option}</span>
//                         </label>
//                       ))}
//                     </div>
//                   )}
//                 </div>
//               )}

//             {propertyType === "Commercial Lease" &&
//               buildingType === "Commercial" &&
//               propertyType2.includes("Retail Shops/Showrooms") && (
//                 <div className="relative w-full sm:w-[260px]">
//                   <button
//                     type="button"
//                     onClick={() => setRetailTypeOpen(!retailTypeOpen)}
//                     className="flex items-center justify-between w-full h-16 px-4 bg-white border-2 border-gray-300 rounded-md"
//                   >
//                     <span>
//                       {retailType.length > 0
//                         ? retailType.join(", ")
//                         : "Retail Type"}
//                     </span>
//                     <RiArrowDropDownLine className="text-2xl" />
//                   </button>

//                   {retailTypeOpen && (
//                     <div className="absolute left-0 z-50 w-full mt-2 bg-white border rounded-md shadow-lg">
//                       {retailTypeOptions.map((option) => (
//                         <label
//                           key={option}
//                           className="flex items-center gap-3 px-3 py-2"
//                         >
//                           <input
//                             type="checkbox"
//                             checked={retailType.includes(option)}
//                             onChange={() => {
//                               setCurrentPage(1);
//                               setRetailType((prev) =>
//                                 prev.includes(option)
//                                   ? prev.filter((i) => i !== option)
//                                   : [...prev, option],
//                               );
//                             }}
//                           />
//                           <span>{option}</span>
//                         </label>
//                       ))}
//                     </div>
//                   )}
//                 </div>
//               )}

//             {propertyType === "Commercial Lease" &&
//               buildingType === "Commercial" &&
//               propertyType2.includes("Other Commercial spaces") && (
//                 <div className="relative w-full sm:w-[260px]">
//                   <button
//                     type="button"
//                     onClick={() => setOtherCommercialOpen(!otherCommercialOpen)}
//                     className="flex items-center justify-between w-full h-16 px-4 bg-white border-2 border-gray-300 rounded-md"
//                   >
//                     <span>
//                       {otherCommercialType.length > 0
//                         ? otherCommercialType.join(", ")
//                         : "Other Commercial Type"}
//                     </span>
//                     <RiArrowDropDownLine className="text-2xl" />
//                   </button>

//                   {otherCommercialOpen && (
//                     <div className="absolute left-0 z-50 w-full mt-2 bg-white border rounded-md shadow-lg">
//                       {otherCommercialOptions.map((option) => (
//                         <label
//                           key={option}
//                           className="flex items-center gap-3 px-3 py-2"
//                         >
//                           <input
//                             type="checkbox"
//                             checked={otherCommercialType.includes(option)}
//                             onChange={() => {
//                               setCurrentPage(1);
//                               setOtherCommercialType((prev) =>
//                                 prev.includes(option)
//                                   ? prev.filter((i) => i !== option)
//                                   : [...prev, option],
//                               );
//                             }}
//                           />
//                           <span>{option}</span>
//                         </label>
//                       ))}
//                     </div>
//                   )}
//                 </div>
//               )}

//             {/* Action Buttons */}
//             <div className="flex flex-wrap gap-4 ">
//               <button
//                 onClick={handleButtonClick}
//                 className="w-40 p-3 text-rose-700 my-border rounded-md hover:bg-gray-300 focus:outline-none"
//               >
//                 {filtersApplied ? "Reset Filters" : "Apply Filter"}
//               </button>
//               <button
//                 className="w-40 p-3 my-border rounded-md hover:bg-gray-300 focus:outline-none"
//                 onClick={handleSaveSearch}
//               >
//                 Save Search
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Main Content */}
//       <div className="flex flex-col p-1 space-y-4 sm:p-6 bg-rose-50 rounded-xl">
//         <div className="flex-grow">
//           <div className="flex flex-col bg-white border-white shadow-md sm:flex-row-reverse">
//             <div
//               className="z-10 flex-1 p-4 border-white no-scrollbar"
//               style={{ scrollbarWidth: "none" }}
//             >
//               {/* Right: Properties */}
//               <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-2">
//                 {properties.length > 0 ? (
//                   properties.map((property) => (
//                     <div
//                       key={property._id}
//                       className={`shadow-md rounded-2xl overflow-hidden block no-underline hover:no-underline ${
//                         hoveredPropertyId === property._id ? "bg-green-200" : ""
//                       }`}
//                       onMouseEnter={() => setHoveredPropertyId(property._id)}
//                       onMouseLeave={() => setHoveredPropertyId(null)}
//                     >
//                       <div className="relative" key={property._id}>
//                         <Link
//                           to={`/propertydetails/${property._id}`}
//                           className="block overflow-hidden no-underline bg-white rounded-lg hover:no-underline"
//                         >
//                           {1 + (property?.property_images?.length || 0) > 1 ? (
//                             <Slider
//                               dots
//                               infinite
//                               speed={500}
//                               slidesToShow={1}
//                               slidesToScroll={1}
//                               arrows
//                               autoplay
//                               autoplaySpeed={2000}
//                               beforeChange={(current, next) =>
//                                 setActiveIndexes((prev) => ({
//                                   ...prev,
//                                   [property._id]: next,
//                                 }))
//                               }
//                               initialSlide={activeIndexes[property._id] || 0}
//                               customPaging={(i) => {
//                                 const activeSlide =
//                                   activeIndexes[property._id] || 0;
//                                 const totalImages =
//                                   1 + (property?.property_images?.length || 0);
//                                 const isActive =
//                                   i === activeSlide % totalImages;
//                                 return (
//                                   <div
//                                     style={{
//                                       width: "10px",
//                                       height: "10px",
//                                       borderRadius: "50%",
//                                       background: isActive ? "#fff" : "#888",
//                                       margin: "0 5px",
//                                       cursor: "pointer",
//                                     }}
//                                   />
//                                 );
//                               }}
//                               appendDots={(dots) => {
//                                 const totalImages =
//                                   1 + (property?.property_images?.length || 0);
//                                 const visibleDots = dots.slice(0, totalImages);
//                                 return (
//                                   <div
//                                     style={{
//                                       position: "absolute",
//                                       bottom: "10px",
//                                       left: "50%",
//                                       transform: "translateX(-50%)",
//                                       display: "flex",
//                                       justifyContent: "center",
//                                       width: "100%",
//                                     }}
//                                   >
//                                     {visibleDots}
//                                   </div>
//                                 );
//                               }}
//                               className="rounded-t-2xl"
//                             >
//                               {/* First slide: cover image */}
//                               <div key={`cover-${property._id}`}>
//                                 <img
//                                   src={property.cover_image}
//                                   alt="Cover"
//                                   className="object-cover w-full h-48 rounded-t-2xl"
//                                 />
//                               </div>

//                               {/* Other property images */}
//                               {(property?.property_images || []).map(
//                                 (imgObj) => (
//                                   <div key={imgObj._id}>
//                                     <img
//                                       src={imgObj.image}
//                                       alt="Property"
//                                       className="object-cover w-full h-48 rounded-t-2xl"
//                                     />
//                                   </div>
//                                 ),
//                               )}
//                             </Slider>
//                           ) : (
//                             <div>
//                               <img
//                                 src={property.cover_image}
//                                 alt="Cover"
//                                 className="object-cover w-full h-48 rounded-t-2xl"
//                               />
//                             </div>
//                           )}
//                         </Link>
//                         {/* 10 Days ZeroBriks Tag (Top Left) */}
//                         <span className="absolute px-2 py-1 text-xs font-normal text-white rounded-full top-2 left-2 bg-gray-800/60 backdrop-blur-sm">
//                           {property.days_since_created} days on ZeroBriks
//                         </span>

//                         {/* Virtual Tour & Heart Icon (Top Right) */}
//                         <div className="absolute flex items-center space-x-2 top-2 right-2">
//                           {property.virtual_tour_availability === "Yes" && (
//                             <span className="flex items-center gap-1 px-2 py-1 text-xs font-normal text-white rounded-full bg-gray-800/60 backdrop-blur-sm">
//                               <PiCubeFocus className="text-sm text-white" />
//                               Virtual Tour
//                             </span>
//                           )}
//                           <button
//                             className="p-1.5 text-xs font-normal text-white bg-opacity-50 rounded-full bg-gray-800/60 backdrop-blur-sm"
//                             onClick={() => {
//                               if (!userId) {
//                                 setIsLoginModalOpen(true);
//                                 return;
//                               }
//                               if (property.is_favorite) {
//                                 removeFromFavorites(property.favorite_id);
//                               } else {
//                                 addToFavorites(property._id);
//                               }
//                             }}
//                           >
//                             <Heart
//                               size={20}
//                               stroke={property.is_favorite ? "none" : "white"}
//                               color={
//                                 property.is_favorite
//                                   ? "red"
//                                   : "rgba(75, 85, 99, 0.4) "
//                               }
//                               fill={
//                                 property.is_favorite
//                                   ? "red"
//                                   : "rgba(75, 85, 99, 0.4) "
//                               }
//                               strokeWidth={2}
//                             />
//                           </button>
//                         </div>

//                         {/* FOR BUY / RENT / UNKNOWN */}
//                         <div className="absolute bottom-0 left-0">
//                           {(() => {
//                             const rawCategory =
//                               property.property_category_type || "";

//                             const normalizedCategory = rawCategory
//                               .replace(/\s+/g, " ")
//                               .replace(/-/g, " ")
//                               .replace(/\//g, " ")
//                               .trim()
//                               .toLowerCase();

//                             let badgeText = "UNKNOWN";
//                             let badgeColor = "bg-gray-500";

//                             if (normalizedCategory === "buy") {
//                               badgeText = "FOR BUY";
//                               badgeColor = "bg-green-500";
//                             } else if (normalizedCategory === "rent") {
//                               badgeText = "FOR RENT";
//                               badgeColor = "bg-blue-500";
//                             } else if (
//                               normalizedCategory.includes("commercial buy")
//                             ) {
//                               badgeText = "COMMERCIAL BUY";
//                               badgeColor = "bg-purple-500";
//                             } else if (
//                               normalizedCategory.includes("commercial lease")
//                             ) {
//                               badgeText = "COMMERCIAL LEASE";
//                               badgeColor = "bg-indigo-500";
//                             } else if (
//                               normalizedCategory.includes("pg") ||
//                               normalizedCategory.includes("co living") ||
//                               normalizedCategory.includes("coliving")
//                             ) {
//                               badgeText = "PG / CO-LIVING";
//                               badgeColor = "bg-yellow-500";
//                             } else if (
//                               normalizedCategory.includes("residential")
//                             ) {
//                               badgeText = "RESIDENTIAL";
//                               badgeColor = "bg-pink-500";
//                             }

//                             return (
//                               <span
//                                 className={`text-white text-xs px-3 py-1 rounded-se-lg ${badgeColor}`}
//                               >
//                                 {badgeText}
//                               </span>
//                             );
//                           })()}
//                         </div>

//                         {/* FEATURED tag - only if marked */}
//                         {property.mark_as_featured === "Yes" && (
//                           <div className="absolute bottom-0 right-0">
//                             <span className="px-3 py-1 text-xs text-white bg-yellow-500 rounded-ss-lg">
//                               FEATURED
//                             </span>
//                           </div>
//                         )}
//                       </div>

//                       {/* Property Description */}
//                       <div className="p-1">
//                         {/* Property Name & Share Button */}
//                         <div className="flex items-center justify-between">
//                           <h3 className="text-xl font-semibold text-gray-800 truncate">
//                             {property.property_name}
//                           </h3>
//                           <PiShareNetworkLight
//                             className="p-2 text-gray-500 bg-white rounded shadow cursor-pointer"
//                             size={32}
//                             onClick={() =>
//                               openShareModal(
//                                 `${window.location.origin}/propertydetails/${property._id}`,
//                                 property._id,
//                               )
//                             }
//                           />
//                         </div>

//                         {/* Property Details (Only 3 elements on top) */}
//                         <div className="flex flex-wrap items-center gap-4 mt-1 text-gray-700">
//                           {/* Price */}
//                           <div className="flex items-center gap-1 text-lg font-semibold">
//                             <FaRupeeSign className="text-xl my-text" />
//                             <span>
//                               {property.property_category_type === "Rent"
//                                 ? `${formatPrice(property.rent)} / ${
//                                     property.rent_duration
//                                   }`
//                                 : formatPrice(property.property_price)}
//                             </span>
//                           </div>

//                           {/* BHK Type */}
//                           {property.bhk_type && (
//                             <div className="flex items-center gap-1">
//                               <MdOutlineBedroomParent className="text-xl my-text" />
//                               <p className="m-0 font-semibold">
//                                 {property.bhk_type}
//                               </p>
//                             </div>
//                           )}

//                           {/* Area in Sq Ft */}
//                           {property.area_sq && (
//                             <div className="flex items-center gap-1">
//                               <BiArea className="text-xl my-text" />
//                               <p className="m-0 font-semibold">
//                                 {property.area_sq} sq ft
//                               </p>
//                             </div>
//                           )}
//                         </div>

//                         {/* Furnished/Semi-Furnished */}
//                         {property.furnished_type && (
//                           <div className="flex items-center mt-2">
//                             <FontAwesomeIcon
//                               icon={faChair}
//                               className="mr-1 my-text"
//                             />
//                             <p className="m-0 font-semibold text-black">
//                               {property.furnished_type}
//                             </p>
//                           </div>
//                         )}

//                         {/* Address */}
//                         <p className="mt-2 text-sm text-gray-400 truncate">
//                           <b>{property.address}</b>
//                         </p>

//                         {/* Owner Section */}
//                         <div className="flex items-center justify-between mb-0 p-2">
//                           {/* LEFT SIDE - Owner */}
//                           <div className="flex flex-col items-center">
//                             <div className="p-2 rounded-full bg-slate-100">
//                               {property.property_owner_image ? (
//                                 <img
//                                   src={`${process.env.REACT_APP_API_URL}/media/${property.property_owner_image}`}
//                                   alt="Owner"
//                                   className="object-cover w-10 h-10 rounded-full"
//                                 />
//                               ) : (
//                                 <AiOutlineUser
//                                   className="text-gray-600"
//                                   size={30}
//                                 />
//                               )}
//                             </div>

//                             <span className="text-sm font-semibold mt-1">
//                               {property.connect_to_name}
//                             </span>

//                             <span className="text-xs text-gray-500">
//                               {property.user_type}
//                             </span>
//                           </div>

//                           {/* RIGHT SIDE - Buttons */}
//                           <div className="flex items-center gap-2">
//                             {/* Contact */}
//                             <div
//                               className="flex items-center justify-center w-24 h-9 text-sm text-white rounded-lg cursor-pointer my-bg"
//                               onClick={() => handleContactClick(property)}
//                             >
//                               Contact
//                             </div>


//                             {/* WhatsApp */}
//                             <a
//                               href={`https://wa.me/91${property.connect_to_no}?text=Hello, I am interested in your property`}
//                               target="_blank"
//                               rel="noopener noreferrer"
//                               onClick={(e) => e.stopPropagation()}
//                               className="flex items-center justify-center w-9 h-9 text-white bg-green-500 rounded-lg hover:bg-green-600"
//                             >
//                               <FaWhatsapp />
//                             </a>

//                             {/* Call */}
//                             <a
//                               href={`tel:${property.connect_to_no}`}
//                               onClick={(e) => e.stopPropagation()}
//                               className="flex items-center justify-center w-9 h-9 text-white bg-blue-500 rounded-lg hover:bg-blue-600"
//                             >
//                               <FaPhone />
//                             </a>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   ))
//                 ) : (
//                   <div className="text-center text-black">
//                     <p>No properties available at the moment.</p>
//                   </div>
//                 )}
//               </div>
//                     {isContactModalOpen && selectedProperty && (
//                              <ContactDetails
//                                fullName={
//                                  freeViewCount <= 0 && paidViewCount <= 0
//                                    ? `****${selectedProperty.connect_to_name?.slice(-1) || "N/A"}`
//                                    : selectedProperty.connect_to_name || "N/A"
//                                }
//                                mobile={
//                                  freeViewCount <= 0 && paidViewCount <= 0
//                                    ? `*******${selectedProperty.connect_to_no?.slice(-3) || "000"}`
//                                    : selectedProperty.connect_to_no || "N/A"
//                                }
//                                showUpgradePrompt={showUpgradePrompt}
//                                onClose={() => setIsContactModalOpen(false)}
//                              />
//                            )}
//               {/* Pagination */}
//               {totalPages > 1 && (
//                 <div className="flex items-center justify-center gap-2 mt-4">
//                   <button
//                     onClick={() => handlePageChange(currentPage - 1)}
//                     disabled={currentPage === 1}
//                     className={`w-8 h-8 flex items-center justify-center rounded-full border-2 border-gray-300 ${
//                       currentPage === 1 ? "opacity-50 cursor-not-allowed" : ""
//                     }`}
//                   >
//                     <MdOutlineNavigateBefore className="text-xl text-gray-700" />
//                   </button>

//                   {/* Render dynamic pagination numbers */}
//                   {getPaginationRange().map((page, index) => (
//                     <button
//                       key={index}
//                       onClick={() =>
//                         page !== "..." ? handlePageChange(page) : null
//                       }
//                       className={`px-3 py-1 text-sm transition-colors ${
//                         currentPage === page
//                           ? "rounded-full my-border w-8 h-8 flex items-center justify-center font-normal"
//                           : "text-gray-700"
//                       }`}
//                     >
//                       {page}
//                     </button>
//                   ))}

//                   <button
//                     onClick={() => handlePageChange(currentPage + 1)}
//                     disabled={currentPage === totalPages}
//                     className={`w-8 h-8 flex items-center justify-center rounded-full border-2 border-gray-300 ${
//                       currentPage === totalPages
//                         ? "opacity-50 cursor-not-allowed"
//                         : ""
//                     }`}
//                   >
//                     <MdOutlineNavigateNext className="text-xl text-gray-700" />
//                   </button>
//                 </div>
//               )}
//             </div>

//             {/* Left: Map */}
//             <div className="flex sticky top-0 w-full sm:w-3/4 md:w-1/2 lg:w-[560px]] h-screen overflow-hidden bg-white rounded-lg">
//               {loading ? (
//                 <p>Loading properties...</p>
//               ) : (
//                 <MapContainer
//                   center={getMapCenter()}
//                   zoom={12}
//                   scrollWheelZoom={false}
//                   style={{ width: "100%", height: "100%" }}
//                 >
//                   <TileLayer url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}" />
//                   {properties.map((property, index) => (
//                     <Marker
//                       key={property._id}
//                       position={[property.latitude, property.longitude]}
//                       icon={createCustomIcon(
//                         property,
//                         property._id === activePropertyId ||
//                           property._id === hoveredPropertyId,
//                       )}
//                       eventHandlers={{
//                         mouseover: () => setHoveredPropertyId(property._id),
//                         mouseout: () => setHoveredPropertyId(null),
//                       }}
//                     >
//                       <Popup>
//                         <div className="w-full sm:w-[300px] relative">
//                           {/* Heart Button */}
//                           <button
//                             className="absolute z-10 top-2 right-2"
//                             onClick={(e) => {
//                               e.preventDefault(); // prevent Link click
//                               if (property.is_favorite) {
//                                 removeFromFavorites(property.favorite_id);
//                               } else {
//                                 addToFavorites(property._id);
//                               }
//                             }}
//                           >
//                             <Heart
//                               size={18}
//                               color={property.is_favorite ? "red" : "white"}
//                               fill={property.is_favorite ? "red" : "white"}
//                             />
//                           </button>

//                           {/* Slider Implementation */}
//                           <div className="relative">
//                             <img
//                               src={
//                                 propertyImages[currentIndex]?.image
//                                   ? `${process.env.REACT_APP_API_URL}${propertyImages[currentIndex]?.image}`
//                                   : `${property.cover_image}`
//                               }
//                               alt={`Property Image ${currentIndex + 1}`}
//                               className="w-full h-[200px] object-cover"
//                             />
//                             <button
//                               onClick={(e) => {
//                                 e.stopPropagation();
//                                 handlePrev();
//                               }}
//                               className="absolute p-1 transform -translate-y-1/2 bg-white rounded top-1/2 left-1 pe-2"
//                             >
//                               <b>&#x3008;</b>
//                             </button>
//                             <button
//                               onClick={(e) => {
//                                 e.stopPropagation();
//                                 handleNext();
//                               }}
//                               className="absolute p-1 transform -translate-y-1/2 bg-white rounded top-1/2 right-1 ps-2"
//                             >
//                               <b>&#x232A;</b>
//                             </button>
//                           </div>

//                           {/* Property Info */}
//                           <div className="px-2">
//                             <div className="flex items-center justify-between text-lg font-semibold text-black">
//                               <div className="flex items-center">
//                                 <BiRupee className="mr-1 text-black bg-white" />
//                                 <span>{property.property_price}</span>
//                               </div>
//                               <Link
//                                 key={property._id}
//                                 to={`/propertydetails/${property._id}`}
//                                 className="block no-underline bg-white border-2 rounded-lg hover:no-underline"
//                               >
//                                 <button className="flex items-center text-white rounded-full btn btn-secondary">
//                                   <b>
//                                     <AiOutlineInfo />
//                                   </b>
//                                 </button>
//                               </Link>
//                             </div>
//                             <div className="text-sm text-gray-600">
//                               <p className="m-0">
//                                 <strong>{property.bhk_type}</strong> |{" "}
//                                 {property.city_name} | {property.area_sq} sq ft
//                               </p>
//                               <p className="m-0">{property.address}</p>
//                             </div>
//                           </div>
//                         </div>
//                       </Popup>
//                     </Marker>
//                   ))}
//                 </MapContainer>
//               )}
//             </div>
//           </div>
//           {isShareModalOpen && (
//             <div className="absolute right-0 z-50">
//               <ShareModal
//                 currentShareUrl={currentShareUrl}
//                 closeShareModal={handleCloseShareModal}
//                 copyLink={() => {
//                   const url = currentShareUrl;

//                   if (navigator.clipboard && window.isSecureContext) {
//                     navigator.clipboard
//                       .writeText(url)
//                       .then(() => alert("Link copied!"))
//                       .catch((err) => {
//                         console.error("Clipboard API failed:", err);
//                         fallbackCopyTextToClipboard(url);
//                       });
//                   } else {
//                     fallbackCopyTextToClipboard(url);
//                   }

//                   function fallbackCopyTextToClipboard(text) {
//                     const textArea = document.createElement("textarea");
//                     textArea.value = text;
//                     textArea.style.position = "fixed"; // avoid scrolling
//                     textArea.style.left = "-9999px";
//                     document.body.appendChild(textArea);
//                     textArea.focus();
//                     textArea.select();

//                     try {
//                       const successful = document.execCommand("copy");
//                       alert(successful ? "Link copied!" : "Copy failed");
//                     } catch (err) {
//                       console.error("Fallback copy failed:", err);
//                       alert("Copy failed");
//                     }

//                     document.body.removeChild(textArea);
//                   }
//                 }}
//               />
//             </div>
//           )}
//         </div>

//         <Login1
//           isOpen={isLoginModalOpen}
//           onClose={() => setIsLoginModalOpen(false)}
//           onSwitchToSignUp={() => {
//             setIsLoginModalOpen(false);
//             setIsSignUpModalOpen(true);
//           }}
//         />
//         <SignUp1
//           isOpen={isSignUpModalOpen}
//           onClose={() => setIsSignUpModalOpen(false)}
//           onSwitchToLogin={() => {
//             setIsSignUpModalOpen(false);
//             setIsLoginModalOpen(true);
//           }}
//         />
//       </div>
//     </>
//   );
// };

// export default FeaturedDashboard;


import React, { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import axios from "axios";
import { Link, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import Slider from "react-slick";
import { Heart } from "lucide-react";
import { RiArrowDropDownLine } from "react-icons/ri";
import {
  MdOutlineNavigateBefore,
  MdOutlineNavigateNext,
  MdOutlineBedroomParent,
} from "react-icons/md";
import { BiArea } from "react-icons/bi";
import { AiOutlineUser, AiOutlineInfo } from "react-icons/ai";
import { FaWhatsapp, FaPhone, FaRupeeSign } from "react-icons/fa";
import { PiCubeFocus } from "react-icons/pi";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShareNodes, faChair } from "@fortawesome/free-solid-svg-icons";
import ShareModal from "../containers/ShareModal";
import ContactDetails from "../containers/ContactDetails";
import Login1 from "../auth/Login1";
import SignUp1 from "../auth/SignUp1";
import { useCity } from "./SearchContext";

// ============================================================
// CONSTANTS
// ============================================================

const API = process.env.REACT_APP_API_URL;
const DEFAULT_CENTER = [18.5204, 73.8567];
const PAGE_SIZE = 10;
const MAX_LOCATIONS = 3;
const TILE_URL =
  "https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}";

const PRICE_OPTIONS = [
  ...Array.from({ length: 19 }, (_, i) => (i + 1) * 500000),
  10000000, 12500000, 15000000, 17500000, 20000000, 25000000, 30000000,
  40000000, 50000000, 75000000, 100000000, 150000000, 200000000, 250000000,
  300000000, 400000000, 500000000, 600000000, 700000000, 750000000, 900000000,
  1000000000, 1500000000, 2000000000, 2500000000, 3000000000, 4000000000,
  5000000000, 6000000000, 7000000000, 7500000000, 9000000000, 10000000000,
];

const AREA_UNITS = [
  "sq.ft", "sq.yards", "sq.m", "acre", "marla", "cents", "bigha", "kottah",
  "kanal", "grounds", "ares", "biswa", "guntha", "aankadam", "hectares",
  "rood", "chataks", "perch",
];

const toOpts = (arr) => arr.map((v) => ({ value: v, label: v }));

const CATEGORY_OPTIONS = [
  { value: "Buy", label: "Buy" },
  { value: "Rent", label: "Rent" },
  { value: "Commercial Buy", label: "Commercial Buy" },
  { value: "Commercial Lease", label: "Commercial Lease" },
  { value: "PG/Co-living", label: "PG / Co-living" },
];
const BUILDING_OPTIONS = ["Residential", "Commercial"];
const BHK_OPTIONS = [
  "Studio", "1 RK", "1 BHK", "1.5 BHK", "2 BHK", "2.5 BHK", "3 BHK",
  "3.5 BHK", "4 BHK", "5 BHK", "6+ BHK",
];
const FURNISHED_OPTIONS = ["Furnished", "Semi-Furnished", "Unfurnished"];
const POSTED_BY_OPTIONS = ["Owner", "Builder"];
const FACING_OPTIONS = [
  "North", "East", "North-East", "South-East", "North-West", "West", "South", "South-West",
];
const YES_NO = ["Yes", "No"];

const CONSTRUCTION_OPTS = toOpts(["Ready To Move", "New Launch", "Under Construction"]);
const AVAILABLE_FROM_OPTS = toOpts([
  "Immediately", "Any Time", "Within 1 Month", "After 1 Month", "Within 3 Month", "After 3 Month",
]);
const SHARING_OPTS = toOpts(["Private Rooms", "2 Per Room", "More than 2 per room"]);
const CAPACITY_OPTS = toOpts(["1-2 guest", "2-4 guest", "4-10 guest", "10+ guest"]);
const CAPACITY_MAP = { "1-2 guest": "1-2", "2-4 guest": "2-4", "4-10 guest": "4-10", "10+ guest": "10+" };
const INVESTMENT_OPTS = toOpts([
  "Pre-leased Spaces", "Restaurants", "SCO Plots", "Business Center",
  "Food Court", "Multiplex", "Co-working",
]);
const PURCHASE_TYPES = ["Resale", "New bookings"];
const PLOT_LAND_OPTS = toOpts([
  "Commercial Land/Inst. Land", "Industrial Lands/Plots", "Agricultural/Farm Land",
]);
const OFFICE_OPTS = toOpts([
  "Ready to move office space", "Bare shell office space", "Co-working office space",
]);
const RETAIL_OPTS = toOpts([
  "Mall", "Commercial Project", "Residential Project", "Retail Complex/Building", "Market/High Street",
]);
const OTHER_COMMERCIAL_OPTS = toOpts([
  "Factory", "Ware House", "Hotel Resorts", "Guest-House/Banquet-Halls",
  "Cold Storage", "Manufacturing", "Others",
]);
const COMMERCIAL_BUY_TYPES = [
  "Ready to move office space", "Bare shell office space", "Ware House", "Factory",
  "Hotel/Resorts", "Others", "Plot/Land", "Cold Storage", "Manufacturing",
  "Guest-House/Banquet-Halls", "Retail",
];
const COMMERCIAL_LEASE_TYPES = ["Office Space", "Retail Shops/Showrooms", "Other Commercial spaces", "Plot/Land"];
const BUY_TYPES = [
  "Flat/Apartment", "Home/Villa", "Service Apartment", "Farmhouse", "Plot/Land",
  "Builder Floor", "1RK/Studio Apartment",
];
const RENT_TYPES = [
  "Flat/Apartment", "Builder Floor", "1RK/Studio Apartment", "Independent House/Villa",
  "Service Apartment", "Farmhouse",
];
const PG_TYPES = [
  "Flat/Apartment", "Builder Floor", "1RK/Studio Apartment", "Independent House/Villa", "Service Apartment",
];
const DEFAULT_TYPES = [
  "Apartment", "Flat/Apartment", "Builder Floor", "Independent House/Villa",
  "Independent/Builder Floor", "1RK/Studio Apartment", "Service Apartment", "Farmhouse",
  "Office", "Retail", "Plot/Land", "Storage", "Industry", "Hospitality", "Other", "Home/Villa",
];
const RENT_AVAILABLE_FOR = ["Family", "Single Women", "Single Men", "Company Guest House"];
const PG_AVAILABLE_FOR = ["Boys", "Girls", "Working"];

const INITIAL_FILTERS = {
  propertyCategory: "",
  buildingType: "",
  propertyTypes: [],
  plotLandTypes: [],
  officeType: [],
  retailType: [],
  otherCommercialType: [],
  bhkType: "",
  minPrice: "",
  maxPrice: "",
  furnishedStatus: "",
  postedBy: "",
  constructionStatus: [],
  amenities: [],
  bathrooms: "",
  facing: "",
  withPhoto: "",
  withVideos: "",
  minArea: "",
  maxArea: "",
  areaIn: "sq.ft",
  sharingType: [],
  availableFrom: [],
  availableFor: [],
  capacity: [],
  investmentOptions: [],
  purchaseType: "",
};

// Cleared when the category changes; amenities and construction are kept
const CATEGORY_RESET = {
  propertyTypes: [],
  plotLandTypes: [],
  officeType: [],
  retailType: [],
  otherCommercialType: [],
  availableFrom: [],
  availableFor: [],
  sharingType: [],
  capacity: [],
  investmentOptions: [],
  purchaseType: "",
};

const selectCls =
  "w-full h-8 px-2 text-xs border border-gray-300 rounded-lg bg-white hover:border-[#8B1E3F] focus:outline-none focus:ring-1 focus:ring-[#8B1E3F] transition-colors disabled:opacity-50 disabled:cursor-not-allowed";
const btnCls =
  "flex items-center justify-between w-full h-8 px-2 text-xs bg-white border border-gray-300 rounded-lg hover:border-[#8B1E3F] focus:outline-none focus:ring-1 focus:ring-[#8B1E3F] transition-colors";
const panelCls =
  "absolute left-0 right-0 z-[999] mt-1 bg-white border border-gray-200 rounded-lg shadow-xl";
const panelSelectCls =
  "w-full p-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-[#8B1E3F]";
const labelCls = "text-xs text-gray-500 mb-1 block";

const STYLE_TEXT = `
  .zb-popup .leaflet-popup-content-wrapper { padding: 0; overflow: hidden; border-radius: 14px; box-shadow: 0 14px 32px -12px rgba(94,13,40,0.35); border: 1px solid #eadfd6; }
  .zb-popup .leaflet-popup-content { margin: 0 !important; width: auto !important; }
  .zb-popup .leaflet-popup-content p { margin: 0; }
  .zb-popup .leaflet-popup-tip { background: #fff; }
  .zb-popup a.leaflet-popup-close-button { top: 8px; right: 8px; width: 26px; height: 26px; line-height: 24px; border-radius: 6px; background: rgba(255,255,255,.95); color: #7a1235; font-size: 18px; text-align: center; padding: 0; z-index: 20; }
  .zb-map .leaflet-top.leaflet-left { top: 8px; left: 8px; }
  .zb-map .leaflet-control-zoom { border: none !important; box-shadow: 0 6px 16px -6px rgba(94,13,40,.4) !important; border-radius: 10px; overflow: hidden; }
  .zb-map .leaflet-control-zoom a { color: #7a1235; background: #fff; border-bottom: 1px solid #eadfd6; width: 34px; height: 34px; line-height: 34px; }
  .zb-map .leaflet-control-zoom a:hover { background: #fbf3ec; color: #5e0d28; }
  .zb-map .leaflet-control-attribution { font-size: 10px; background: rgba(255,255,255,.8); }
  .marker-wrapper { position: relative; display: flex; justify-content: center; align-items: center; }
  .custom-marker { display: flex; align-items: center; justify-content: center; }
  .price-tooltip { position: relative; background: #fff; color: #1f2937; padding: 5px 10px; border-radius: 16px; border: 1px solid #eadfd6; font-size: 12px; font-weight: 700; white-space: nowrap; box-shadow: 0 4px 12px rgba(0,0,0,.2); transition: background-color .2s ease, color .2s ease, border-color .2s ease, transform .2s ease; }
  .price-tooltip .pointer { position: absolute; bottom: -7px; left: 50%; transform: translateX(-50%); width: 0; height: 0; border-left: 7px solid transparent; border-right: 7px solid transparent; border-top: 7px solid #fff; }
  .custom-marker.active .price-tooltip { background: #7a1235; color: #fff; border-color: #7a1235; transform: scale(1.08); }
  .custom-marker.active .price-tooltip .pointer { border-top-color: #7a1235; }
  .zb-card .slick-slide img { transition: transform .6s ease; }
  .zb-card:hover .slick-slide img { transform: scale(1.05); }
  .zb-card .slick-prev, .zb-card .slick-next { z-index: 5; width: 28px; height: 28px; opacity: 0; transition: opacity .25s ease; }
  .zb-card .slick-prev { left: 8px; }
  .zb-card .slick-next { right: 8px; }
  .zb-card:hover .slick-prev, .zb-card:hover .slick-next { opacity: 1; }
  .zb-card .slick-prev:before, .zb-card .slick-next:before { font-size: 28px; text-shadow: 0 2px 6px rgba(0,0,0,.45); }
`;

// ============================================================
// PURE HELPERS
// ============================================================

const parseCities = (str) =>
  str ? str.split(",").map((c) => c.trim()).filter(Boolean) : [];

const formatPriceMinMax = (value) => {
  const num = Number(value);
  if (num >= 10000000) return (num / 10000000).toFixed(1).replace(/\.0$/, "") + " Cr";
  if (num >= 100000) return (num / 100000).toFixed(1).replace(/\.0$/, "") + " L";
  if (num >= 1000) return (num / 1000).toFixed(1).replace(/\.0$/, "") + " K";
  return num;
};

const formatPrice = (price) => {
  const n = Number(price);
  if (!price || Number.isNaN(n) || n <= 0) return "On request";
  if (n >= 10000000) return `₹ ${(n / 10000000).toFixed(2)} Cr`;
  if (n >= 100000) return `₹ ${(n / 100000).toFixed(2)} L`;
  if (n >= 1000) return `₹ ${(n / 1000).toFixed(2)} K`;
  return `₹ ${n}`;
};

const formatAmount = (value) => {
  const n = Number(value);
  if (!n) return value || "N/A";
  if (n >= 10000000) return (n / 10000000).toFixed(1).replace(/\.0$/, "") + " Cr";
  if (n >= 100000) return (n / 100000).toFixed(1).replace(/\.0$/, "") + " L";
  if (n >= 1000) return (n / 1000).toFixed(1).replace(/\.0$/, "") + " K";
  return String(n);
};

const getCategoryText = (type) => {
  const raw = (type || "").replace(/[\s\-/]+/g, " ").trim().toLowerCase();
  if (raw === "buy") return "FOR BUY";
  if (raw === "rent") return "FOR RENT";
  if (raw.includes("commercial buy")) return "COMMERCIAL BUY";
  if (raw.includes("commercial lease")) return "COMMERCIAL LEASE";
  if (raw.includes("pg") || raw.includes("co living") || raw.includes("coliving")) return "PG / CO-LIVING";
  if (raw.includes("residential")) return "RESIDENTIAL";
  return "UNKNOWN";
};

const getListedPrice = (p) => {
  const primary = p.property_category_type === "Rent" ? p.rent : p.property_price;
  return primary ?? p.property_price ?? p.rent ?? null;
};

const hasValidCoords = (p) =>
  p.latitude != null &&
  p.longitude != null &&
  Number.isFinite(parseFloat(p.latitude)) &&
  Number.isFinite(parseFloat(p.longitude));

const isCommercialLease = (f) =>
  f.propertyCategory === "Commercial Lease" && f.buildingType === "Commercial";

const hasActiveFilters = (f) =>
  Object.entries(f).some(
    ([k, v]) => k !== "areaIn" && (Array.isArray(v) ? v.length > 0 : v !== ""),
  );

const getPropertyTypeOptions = (f) => {
  if (isCommercialLease(f)) return toOpts(COMMERCIAL_LEASE_TYPES);
  if (f.propertyCategory === "Commercial Buy" || f.buildingType === "Commercial")
    return toOpts(COMMERCIAL_BUY_TYPES);
  if (f.propertyCategory === "Buy") return toOpts(BUY_TYPES);
  if (f.propertyCategory === "Rent") return toOpts(RENT_TYPES);
  if (f.propertyCategory === "PG/Co-living") return toOpts(PG_TYPES);
  return toOpts(DEFAULT_TYPES);
};

// Maps commercial selections to the API's property_type / office_type / sub_sub_property_type
const mapCommercialTypes = (f) => {
  const property_type = [];
  const office_type = [];
  const sub_sub_property_type = [];
  const lease = isCommercialLease(f);

  f.propertyTypes.forEach((raw) => {
    const t = raw.trim();
    if (lease) {
      if (t === "Office Space") {
        property_type.push("Office");
        office_type.push(...f.officeType);
      } else if (t === "Retail Shops/Showrooms") {
        property_type.push("Retail");
        sub_sub_property_type.push(...f.retailType);
      } else if (t === "Other Commercial spaces") {
        f.otherCommercialType.forEach((i) =>
          i === "Others" ? sub_sub_property_type.push("Others") : office_type.push(i),
        );
      } else if (t === "Plot/Land") {
        property_type.push("Plot/Land");
        office_type.push(...f.plotLandTypes);
      }
    } else if (t === "Plot/Land") {
      property_type.push("Plot/Land");
      office_type.push(...f.plotLandTypes);
    } else if (t === "Retail") {
      property_type.push("Retail");
    } else if (t === "Others") {
      sub_sub_property_type.push("Others");
    } else {
      office_type.push(t);
    }
  });

  return { property_type, office_type, sub_sub_property_type };
};

// Single source of truth for filter request params (listing and save-search)
const appendFilterParams = (fd, f, { userType, bathroomKey }) => {
  if (f.buildingType) fd.append("building_type", f.buildingType);

  if (f.propertyCategory) {
    const apiCategory =
      f.propertyCategory === "Commercial Buy"
        ? "Buy"
        : f.propertyCategory === "Commercial Lease"
          ? "Rent"
          : f.propertyCategory;
    fd.append("property_category_type", apiCategory);
  }

  const isCommercial = f.propertyCategory === "Commercial Buy" || isCommercialLease(f);
  if (isCommercial) {
    const m = mapCommercialTypes(f);
    if (m.property_type.length) fd.append("property_type", m.property_type.join(","));
    if (m.office_type.length) fd.append("office_type", m.office_type.join(","));
    if (m.sub_sub_property_type.length)
      fd.append("sub_sub_property_type", m.sub_sub_property_type.join(","));
  } else if (f.propertyTypes.length) {
    fd.append("property_type", f.propertyTypes.join(","));
  }

  if (f.bhkType) fd.append("bhk_type", f.bhkType);
  if (f.furnishedStatus) fd.append("furnished_type", f.furnishedStatus);
  if (f.minPrice) fd.append("min_price", f.minPrice);
  if (f.maxPrice) fd.append("max_price", f.maxPrice);
  if (f.minArea) fd.append("min_area", f.minArea);
  if (f.maxArea) fd.append("max_area", f.maxArea);
  if ((f.minArea || f.maxArea) && f.areaIn) fd.append("area_in", f.areaIn);
  if (userType) fd.append("user_type", userType);

  if (f.constructionStatus.length) fd.append("construction_status", f.constructionStatus.join(","));
  if (f.amenities.length) fd.append("amenities", f.amenities.join(","));
  if (f.bathrooms) fd.append(bathroomKey, f.bathrooms);
  if (f.facing) fd.append("facing", f.facing);
  if (f.withPhoto) fd.append("with_photo", f.withPhoto);
  if (f.withVideos) fd.append("with_videos", f.withVideos);

  if (f.availableFor.length) fd.append("available_for", f.availableFor.join(","));
  if (f.sharingType.length) fd.append("sharing_type", f.sharingType.join(","));
  if (f.availableFrom.length) fd.append("available_from", f.availableFrom.join(","));
  if (f.capacity.length)
    fd.append("available_beds", f.capacity.map((c) => CAPACITY_MAP[c]).join(","));
  if (f.investmentOptions.length) fd.append("investment_options", f.investmentOptions.join(","));
  if (f.purchaseType) fd.append("purchase_type", f.purchaseType);
};

const budgetLabel = (f) => {
  if (f.minPrice && f.maxPrice)
    return `${formatPriceMinMax(f.minPrice)} - ${formatPriceMinMax(f.maxPrice)}`;
  if (f.minPrice) return `Above ${formatPriceMinMax(f.minPrice)}`;
  if (f.maxPrice) return `Below ${formatPriceMinMax(f.maxPrice)}`;
  return "Budget";
};

const areaLabel = (f) =>
  f.minArea || f.maxArea ? `${f.minArea || 0} - ${f.maxArea || "Any"} ${f.areaIn}` : "Area";

const getPaginationRange = (current, total) => {
  const range = [];
  const groupSize = 3;
  const groupStart = Math.floor((current - 1) / groupSize) * groupSize + 1;
  const groupEnd = Math.min(groupStart + groupSize - 1, total);
  for (let i = groupStart; i <= groupEnd; i++) range.push(i);
  if (groupEnd < total) range.push("...", total);
  return range;
};

const fallbackCopy = (text) => {
  const ta = document.createElement("textarea");
  ta.value = text;
  ta.style.position = "fixed";
  ta.style.left = "-9999px";
  document.body.appendChild(ta);
  ta.focus();
  ta.select();
  let ok = false;
  try {
    ok = document.execCommand("copy");
  } catch {
    ok = false;
  }
  document.body.removeChild(ta);
  ok ? toast.success("Link copied!") : toast.error("Copy failed");
};

// Google Maps loads once per page, shared by every mount
let mapsPromise = null;
const loadGoogleMaps = () => {
  if (window.google?.maps?.places) return Promise.resolve();
  if (!mapsPromise) {
    mapsPromise = new Promise((resolve, reject) => {
      const s = document.createElement("script");
      s.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_KEY}&libraries=places`;
      s.async = true;
      s.onload = resolve;
      s.onerror = () => {
        mapsPromise = null;
        reject(new Error("Google Maps failed to load"));
      };
      document.head.appendChild(s);
    });
  }
  return mapsPromise;
};

// Price markers are cached by label and active state
const iconCache = new Map();
const getPriceIcon = (price, isActive) => {
  const label = formatPrice(price);
  const key = `${label}|${isActive}`;
  let icon = iconCache.get(key);
  if (!icon) {
    icon = L.divIcon({
      className: `custom-marker ${isActive ? "active" : ""}`,
      html: `<div class="marker-wrapper"><div class="price-tooltip">${label}<div class="pointer"></div></div></div>`,
      iconSize: [50, 60],
      iconAnchor: [25, 60],
    });
    if (iconCache.size > 500) iconCache.clear();
    iconCache.set(key, icon);
  }
  return icon;
};

// ============================================================
// HOOKS
// ============================================================

const useDebouncedValue = (value, delay) => {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debounced;
};

// ============================================================
// SUB-COMPONENTS
// ============================================================

const MultiDropdown = ({
  id,
  label,
  options,
  selected,
  onToggle,
  onClear,
  openId,
  setOpenId,
  radio = false,
}) => {
  const isOpen = openId === id;
  const picked = options.filter((o) => selected.includes(o.value)).map((o) => o.label);
  const summary =
    picked.length === 0 ? label : picked.length === 1 ? picked[0] : `${picked.length} selected`;

  return (
    <div className="relative">
      <button type="button" onClick={() => setOpenId(isOpen ? null : id)} className={btnCls}>
        <span className="truncate text-gray-700">{summary}</span>
        <RiArrowDropDownLine className="text-lg text-gray-500 shrink-0" />
      </button>

      {isOpen && (
        <div className={`${panelCls} max-h-64 overflow-y-auto`}>
          {options.map((o) => (
            <label
              key={o.value}
              className="flex items-center gap-2 px-3 py-2 text-sm cursor-pointer hover:bg-[#8B1E3F]/5"
            >
              <input
                type={radio ? "radio" : "checkbox"}
                name={id}
                checked={selected.includes(o.value)}
                onChange={() => onToggle(o.value)}
                className="accent-[#8B1E3F]"
              />
              {o.label}
            </label>
          ))}
          <div className="sticky bottom-0 flex gap-2 p-2 bg-white border-t">
            <button
              type="button"
              onClick={onClear}
              className="flex-1 py-1.5 text-xs border rounded-md hover:bg-gray-50"
            >
              Clear
            </button>
            <button
              type="button"
              onClick={() => setOpenId(null)}
              className="flex-1 py-1.5 text-xs text-white bg-[#8B1E3F] rounded-md hover:bg-[#7a1a37]"
            >
              Done
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

const Skeleton = () => (
  <div className="flex flex-col gap-2 animate-pulse">
    <div className="h-[130px] rounded-xl bg-gray-200" />
    <div className="h-28 rounded-xl bg-gray-100" />
  </div>
);

const MapPanner = ({ target }) => {
  const map = useMap();
  useEffect(() => {
    if (!target) return;
    map.flyTo([target.lat, target.lng], Math.max(map.getZoom(), 12), { duration: 0.8 });
  }, [target, map]);
  return null;
};

const PropertyCard = memo(function PropertyCard({
  property: p,
  isHovered,
  onEnter,
  onLeave,
  onFavorite,
  onShare,
  onContact,
}) {
  const [slide, setSlide] = useState(0);
  const images = useMemo(
    () => [p.cover_image, ...(p.property_images || []).map((i) => i.image)].filter(Boolean),
    [p.cover_image, p.property_images],
  );
  const isRent = p.property_category_type === "Rent";
  const duration =
    isRent && p.rent_duration && p.rent_duration !== "N/A" ? ` / ${p.rent_duration}` : "";
  const detailsPath = `/propertydetails/${p._id}`;
  const waText = encodeURIComponent("Hello, I am interested in your property");

  return (
    <div
      className={`zb-card group flex flex-col gap-2 transition-transform duration-300 ${
        isHovered ? "-translate-y-0.5" : "hover:-translate-y-0.5"
      }`}
      onMouseEnter={() => onEnter(p)}
      onMouseLeave={onLeave}
    >
      {/* Image box */}
      <div
        className={`relative h-[130px] shrink-0 overflow-hidden rounded-xl bg-slate-900 transition-shadow duration-300 ${
          isHovered ? "ring-2 ring-[#7a1235] shadow-lg" : "shadow-sm"
        }`}
      >
        <Link to={detailsPath} className="absolute inset-0 block overflow-hidden">
          {images.length > 1 ? (
            <Slider
              dots={false}
              arrows={false}
              infinite
              speed={600}
              slidesToShow={1}
              slidesToScroll={1}
              autoplay
              autoplaySpeed={2800}
              beforeChange={(_, next) => setSlide(next)}
            >
              {images.map((src, i) => (
                <div key={`${p._id}-${i}`}>
                  <img src={src} alt={p.property_name || "Property"} loading="lazy" className="object-cover w-full h-[130px]" />
                </div>
              ))}
            </Slider>
          ) : (
            <img
              src={p.cover_image}
              alt={p.property_name || "Property"}
              loading="lazy"
              className="object-cover w-full h-[130px] transition-transform duration-700 group-hover:scale-105"
            />
          )}
        </Link>

        <div className="absolute inset-x-0 top-0 h-12 pointer-events-none bg-gradient-to-b from-black/50 to-transparent" />

        <div className="absolute z-10 flex flex-col items-start gap-1 pointer-events-none top-2 left-2">
          <span className="px-1.5 py-0.5 text-[10px] font-medium text-white rounded bg-black/45 backdrop-blur">
            {p.days_since_created} days on ZeroBriks
          </span>
          <div className="flex items-center gap-1">
            <span className="px-1.5 py-0.5 text-[10px] font-semibold tracking-wide text-white rounded shadow bg-[#7a1235]">
              {getCategoryText(p.property_category_type)}
            </span>
            {p.mark_as_featured === "Yes" && (
              <span className="px-1.5 py-0.5 text-[10px] font-bold tracking-wide text-[#5e0d28] rounded shadow bg-[#e3b23c]">
                ★ FEATURED
              </span>
            )}
          </div>
        </div>

        <div className="absolute z-10 flex items-center gap-1 top-2 right-2">
          {p.virtual_tour_availability === "Yes" && (
            <span className="flex items-center gap-1 px-1.5 py-0.5 text-[10px] font-medium text-white rounded-full pointer-events-none bg-black/45 backdrop-blur">
              <PiCubeFocus className="text-xs text-[#e3b23c]" /> Tour
            </span>
          )}
          <button
            type="button"
            aria-label={p.is_favorite ? "Remove from favourites" : "Add to favourites"}
            className="flex items-center justify-center transition-transform rounded-full w-7 h-7 bg-white/90 backdrop-blur shadow hover:bg-white hover:scale-110 active:scale-95"
            onClick={() => onFavorite(p)}
          >
            <Heart
              size={14}
              color={p.is_favorite ? "#e11d48" : "#7a1235"}
              fill={p.is_favorite ? "#e11d48" : "transparent"}
              strokeWidth={2}
            />
          </button>
        </div>

        {images.length > 1 && (
          <div className="absolute z-10 flex gap-1 pointer-events-none bottom-2 left-1/2 -translate-x-1/2">
            {images.map((_, i) => (
              <span
                key={i}
                className="h-1 rounded-full transition-all duration-300"
                style={{
                  width: i === slide ? "12px" : "5px",
                  background: i === slide ? "#e3b23c" : "rgba(255,255,255,0.6)",
                }}
              />
            ))}
          </div>
        )}
      </div>

      {/* Details */}
      <div
        className={`flex flex-col flex-1 min-h-0 gap-2 p-3 bg-white rounded-xl border transition-colors duration-300 ${
          isHovered ? "border-[#7a1235] shadow-md" : "border-[#eadfd6] shadow-sm"
        }`}
      >
        <div className="min-w-0">
          <div className="flex items-start justify-between gap-2">
            <Link to={detailsPath} className="min-w-0 no-underline hover:no-underline">
              <h3 className="m-0 text-sm font-semibold leading-snug text-gray-900 truncate hover:text-[#7a1235] transition-colors">
                {p.property_name}
              </h3>
            </Link>
            <button
              type="button"
              aria-label="Share property"
              className="p-1 -mt-0.5 text-[#7a1235] rounded-md hover:bg-[#fbf3ec] transition-colors shrink-0"
              onClick={() => onShare(p)}
            >
              <FontAwesomeIcon icon={faShareNodes} className="text-xs" />
            </button>
          </div>
          <p className="flex items-center gap-1 mt-0.5 mb-0 text-[11px] text-gray-500">
            <img
              src="/image/address_icon.png"
              alt="Location"
              className="object-contain w-3 h-3 shrink-0"
              onError={(e) => {
                e.target.style.display = "none";
              }}
            />
            <span className="truncate">{p.address_area || p.address || "No Address Provided"}</span>
          </p>
        </div>

        <div className="flex items-end justify-between gap-2 min-w-0">
          <div className="flex items-baseline gap-0.5 min-w-0 text-base font-bold text-[#7a1235]">
            <FaRupeeSign className="text-xs self-center" />
            <span>{isRent ? formatAmount(p.rent) : formatAmount(p.property_price)}</span>
            {duration && <span className="text-[10px] font-medium text-gray-500">{duration}</span>}
          </div>

          {(p.bhk_type || p.area_sq || p.furnished_type) && (
            <div className="flex flex-wrap justify-end gap-1 text-[10px] text-gray-700">
              {p.bhk_type && (
                <span className="flex items-center gap-1 px-1.5 py-0.5 rounded bg-[#fbf3ec]">
                  <MdOutlineBedroomParent className="text-xs text-[#7a1235]" />
                  {p.bhk_type}
                </span>
              )}
              {p.area_sq && (
                <span className="flex items-center gap-1 px-1.5 py-0.5 rounded bg-[#fbf3ec]">
                  <BiArea className="text-xs text-[#7a1235]" />
                  {p.area_sq} sq ft
                </span>
              )}
              {p.furnished_type && (
                <span className="flex items-center gap-1 px-1.5 py-0.5 rounded bg-[#fbf3ec]">
                  <FontAwesomeIcon icon={faChair} className="text-[10px] text-[#7a1235]" />
                  {p.furnished_type}
                </span>
              )}
            </div>
          )}
        </div>

        <div className="flex items-center gap-2 pt-2 mt-auto border-t border-[#eadfd6] min-w-0">
          <div className="flex items-center justify-center w-6 h-6 overflow-hidden rounded-full shrink-0 bg-[#fbf3ec]">
            {p.property_owner_image ? (
              <img
                src={`${API}/media/${p.property_owner_image}`}
                alt="Owner"
                loading="lazy"
                className="object-cover w-6 h-6"
              />
            ) : (
              <AiOutlineUser className="text-[#7a1235]" size={14} />
            )}
          </div>
          <div className="flex items-baseline gap-1 min-w-0 text-[11px]">
            <span className="font-semibold text-gray-900 truncate">{p.connect_to_name}</span>
            <span className="text-gray-500 truncate">· {p.user_type}</span>
          </div>
        </div>

        <div className="grid grid-cols-3 gap-1.5">
          <button
            type="button"
            className="flex items-center justify-center h-8 text-[11px] font-semibold text-white rounded-lg bg-[#7a1235] hover:bg-[#5e0d28] active:scale-95 transition-all"
            onClick={() => onContact(p)}
          >
            Contact
          </button>
          <a
            href={`https://wa.me/91${p.connect_to_no}?text=${waText}`}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
            className="flex items-center justify-center gap-1 h-8 text-[11px] font-semibold text-white rounded-lg bg-[#25D366] hover:brightness-110 active:scale-95 transition-all"
          >
            <FaWhatsapp className="text-sm" />
            WhatsApp
          </a>
          <a
            href={`tel:${p.connect_to_no}`}
            onClick={(e) => e.stopPropagation()}
            className="flex items-center justify-center gap-1 h-8 text-[11px] font-semibold text-[#7a1235] rounded-lg border border-[#7a1235] bg-white hover:bg-[#7a1235] hover:text-white active:scale-95 transition-all"
          >
            <FaPhone className="text-xs" />
            Call
          </a>
        </div>
      </div>
    </div>
  );
});

// Preview card shown on marker hover: gallery, price, specs, address
const MarkerPopup = ({ p, onFavorite, onEnter, onLeave }) => {
  const images = useMemo(
    () => [p.cover_image, ...(p.property_images || []).map((i) => i.image)].filter(Boolean),
    [p.cover_image, p.property_images],
  );
  const [idx, setIdx] = useState(0);
  const count = images.length || 1;
  const src = images[idx % count] || p.cover_image;

  const step = (e, dir) => {
    e.stopPropagation();
    setIdx((i) => (i + dir + count) % count);
  };

  const isRent = p.property_category_type === "Rent";
  const duration =
    isRent && p.rent_duration && p.rent_duration !== "N/A" ? ` / ${p.rent_duration}` : "";
  const specs = [p.bhk_type, p.city_name, p.area_sq ? `${p.area_sq} sq ft` : null].filter(Boolean);

  return (
    <div className="w-[240px] sm:w-[280px] bg-white" onMouseEnter={onEnter} onMouseLeave={onLeave}>
      <div className="relative h-[170px] bg-slate-900">
        <img src={src} alt={p.property_name || "Property"} loading="lazy" className="w-full h-full object-cover" />

        <button
          type="button"
          aria-label={p.is_favorite ? "Remove from favourites" : "Add to favourites"}
          onClick={(e) => {
            e.stopPropagation();
            onFavorite(p);
          }}
          className="absolute z-10 top-2 right-2 flex items-center justify-center w-8 h-8 rounded-full bg-white/90 shadow hover:bg-white"
        >
          <Heart
            size={16}
            color={p.is_favorite ? "#e11d48" : "#7a1235"}
            fill={p.is_favorite ? "#e11d48" : "transparent"}
            strokeWidth={2}
          />
        </button>

        {count > 1 && (
          <>
            <button
              type="button"
              aria-label="Previous image"
              onClick={(e) => step(e, -1)}
              className="absolute top-1/2 left-1.5 -translate-y-1/2 w-7 h-7 flex items-center justify-center rounded-full bg-white/90 hover:bg-white text-sm"
            >
              ‹
            </button>
            <button
              type="button"
              aria-label="Next image"
              onClick={(e) => step(e, 1)}
              className="absolute top-1/2 right-1.5 -translate-y-1/2 w-7 h-7 flex items-center justify-center rounded-full bg-white/90 hover:bg-white text-sm"
            >
              ›
            </button>
          </>
        )}
      </div>

      <div className="p-3">
        <div className="flex items-center justify-between gap-2">
          <span className="flex items-baseline gap-0.5 text-base font-bold text-[#7a1235]">
            <FaRupeeSign className="text-xs self-center" />
            {formatAmount(getListedPrice(p))}
            {duration && <span className="text-[10px] font-medium text-gray-500">{duration}</span>}
          </span>
          <Link
            to={`/propertydetails/${p._id}`}
            aria-label="View details"
            className="flex items-center justify-center w-8 h-8 rounded-full bg-[#7a1235] text-white hover:bg-[#5e0d28]"
          >
            <AiOutlineInfo />
          </Link>
        </div>

        <div className="mt-1 text-xs font-semibold text-gray-800 truncate">{p.property_name}</div>
        {specs.length > 0 && (
          <div className="text-[11px] text-gray-600 truncate">{specs.join(" | ")}</div>
        )}
        <div className="text-[11px] text-gray-500 truncate">
          {p.address_area || p.address || "No Address Provided"}
        </div>
      </div>
    </div>
  );
};

// Marker: hover opens the preview card; the card stays open while the cursor is on it
const PropertyMarker = memo(function PropertyMarker({
  property: p,
  isActive,
  onHover,
  onLeave,
  onFavorite,
}) {
  const markerRef = useRef(null);
  const closeTimer = useRef(null);

  const openCard = () => {
    clearTimeout(closeTimer.current);
    markerRef.current?.openPopup();
  };
  const scheduleClose = () => {
    clearTimeout(closeTimer.current);
    closeTimer.current = setTimeout(() => markerRef.current?.closePopup(), 150);
  };
  const keepOpen = () => clearTimeout(closeTimer.current);

  useEffect(() => () => clearTimeout(closeTimer.current), []);

  return (
    <Marker
      ref={markerRef}
      position={[parseFloat(p.latitude), parseFloat(p.longitude)]}
      icon={getPriceIcon(getListedPrice(p), isActive)}
      zIndexOffset={isActive ? 1000 : 0}
      eventHandlers={{
        mouseover: () => {
          onHover(p._id);
          openCard();
        },
        mouseout: () => {
          onLeave();
          scheduleClose();
        },
      }}
    >
      <Popup className="zb-popup" minWidth={240} maxWidth={280} autoPan={false}>
        <MarkerPopup p={p} onFavorite={onFavorite} onEnter={keepOpen} onLeave={scheduleClose} />
      </Popup>
    </Marker>
  );
});

// ============================================================
// MAIN COMPONENT
// ============================================================

const FeaturedDashboard = () => {
  const location = useLocation();
  const propertytype = location.state?.propertyType || "";
  const accessToken = sessionStorage.getItem("accessToken");
  const cityFromSession = sessionStorage.getItem("cityName");
  const { searchCity, setSearchCity } = useCity();

  const selectedLocations = useMemo(
    () => parseCities(searchCity || cityFromSession || ""),
    [searchCity, cityFromSession],
  );
  const cities = selectedLocations.join(", ");
  const canAddLocation = selectedLocations.length < MAX_LOCATIONS;

  // ---------- State ----------
  const [filters, setFilters] = useState(INITIAL_FILTERS);
  const [page, setPage] = useState(1);
  const [items, setItems] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [reloadKey, setReloadKey] = useState(0);
  const [amenitiesList, setAmenitiesList] = useState([]);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [showMoreFilters, setShowMoreFilters] = useState(false);
  const [locationInput, setLocationInput] = useState("");
  const [hoveredId, setHoveredId] = useState(null);
  const [panTarget, setPanTarget] = useState(null);
  const [counts, setCounts] = useState({ free: 0, paid: 0 });
  const [contact, setContact] = useState({ open: false, property: null, upgrade: false });
  const [share, setShare] = useState({ open: false, url: "" });
  const [authModal, setAuthModal] = useState(null); // "login" | "signup" | null

  const locationInputRef = useRef(null);
  const filterBarRef = useRef(null);
  const addLocationRef = useRef(() => {});

  // ---------- Query (debounced so typing and rapid clicks make one request) ----------
  const queryKey = JSON.stringify({
    propertytype,
    accessToken,
    cities,
    filters,
    page,
    reloadKey,
  });
  const debouncedKey = useDebouncedValue(queryKey, 300);

  useEffect(() => {
    const q = JSON.parse(debouncedKey);
    const f = q.filters;
    const controller = new AbortController();
    const { signal } = controller;

    const run = async () => {
      setLoading(true);
      setError(null);
      try {
        let res;
        if (hasActiveFilters(f)) {
          // Filtered view: same filter contract as Search, limited to featured listings
          const fd = new FormData();
          fd.append("customer_id", q.accessToken || "");
          fd.append("page", q.page);
          fd.append("page_size", PAGE_SIZE);
          fd.append("mark_as_featured", "Yes");
          if (q.cities) fd.append("city_name", q.cities);
          appendFilterParams(fd, f, {
            userType: f.postedBy,
            bathroomKey: "no_of_bathrooms",
          });
          res = await axios.post(`${API}/cust_api/filter_property`, fd, { signal });
        } else {
          // Default featured feed
          res = await axios.post(
            `${API}/cust_api/get_featured_property`,
            {
              user_id: q.accessToken,
              property_category_type: q.propertytype,
              page: q.page,
              page_size: PAGE_SIZE,
              city_name: q.cities,
            },
            { signal },
          );
        }

        if (signal.aborted) return;
        if (res.data?.status === 1) {
          setItems(res.data.data || []);
          setTotalPages(res.data.total_pages || 1);
        } else {
          setItems([]);
          setTotalPages(1);
          setError("No properties available");
        }
      } catch (err) {
        if (axios.isCancel(err) || signal.aborted) return;
        setItems([]);
        setTotalPages(1);
        setError(err?.response?.data?.message || "Failed to load properties.");
      } finally {
        if (!signal.aborted) setLoading(false);
      }
    };

    run();
    return () => controller.abort();
  }, [debouncedKey]);

  // ---------- Amenities (once) ----------
  useEffect(() => {
    axios
      .post("https://api.nowaybroker.com/cust_api/get_amenities", new FormData())
      .then((res) => {
        if (res.data?.status === 1) setAmenitiesList(res.data.data || []);
      })
      .catch((err) => console.log("Amenities fetch failed", err));
  }, []);

  // ---------- Derived ----------
  const visible = useMemo(() => items.filter(hasValidCoords), [items]);
  const mapCenter = visible.length
    ? [parseFloat(visible[0].latitude), parseFloat(visible[0].longitude)]
    : DEFAULT_CENTER;

  const isCL = isCommercialLease(filters);
  const isCB = filters.propertyCategory === "Commercial Buy";
  const isRent = filters.propertyCategory === "Rent";
  const isPG = filters.propertyCategory === "PG/Co-living";
  const showPlotLand = (isCB || isCL) && filters.propertyTypes.includes("Plot/Land");
  const showFacing = filters.propertyTypes.includes("Plot/Land") || filters.plotLandTypes.length > 0;

  const propertyTypeOptions = useMemo(
    () => getPropertyTypeOptions(filters),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [filters.propertyCategory, filters.buildingType],
  );
  const amenityOptions = useMemo(
    () => amenitiesList.map((a) => ({ value: String(a._id), label: a.amenity_name })),
    [amenitiesList],
  );
  const availableForOptions = useMemo(() => {
    if (isRent) return toOpts(RENT_AVAILABLE_FOR);
    if (isPG) return toOpts(PG_AVAILABLE_FOR);
    return [];
  }, [isRent, isPG]);

  // ---------- Filter handlers ----------
  const closeDropdown = useCallback(() => setOpenDropdown(null), []);
  const toggleOpen = useCallback((id) => setOpenDropdown((cur) => (cur === id ? null : id)), []);

  // Close an open dropdown when clicking outside the filter bar
  useEffect(() => {
    if (!openDropdown) return;
    const onDown = (e) => {
      if (filterBarRef.current && !filterBarRef.current.contains(e.target)) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, [openDropdown]);

  const patchFilters = useCallback((patch) => {
    setFilters((prev) => ({ ...prev, ...patch }));
    setPage(1);
  }, []);

  const toggleList = useCallback((key, value) => {
    setFilters((prev) => {
      const cur = prev[key];
      return {
        ...prev,
        [key]: cur.includes(value) ? cur.filter((v) => v !== value) : [...cur, value],
      };
    });
    setPage(1);
  }, []);

  const clearList = useCallback((key) => patchFilters({ [key]: [] }), [patchFilters]);

  const togglePropertyType = useCallback((type) => {
    setFilters((prev) => {
      const next = isCommercialLease(prev)
        ? [type]
        : prev.propertyTypes.includes(type)
          ? prev.propertyTypes.filter((t) => t !== type)
          : [...prev.propertyTypes, type];
      return {
        ...prev,
        propertyTypes: next,
        plotLandTypes: next.includes("Plot/Land") ? prev.plotLandTypes : [],
      };
    });
    setPage(1);
  }, []);

  const handleCategoryChange = (value) => {
    const commercial = value === "Commercial Buy" || value === "Commercial Lease";
    patchFilters({
      ...CATEGORY_RESET,
      propertyCategory: value,
      buildingType: commercial ? "Commercial" : "",
    });
  };

  const stepBathrooms = (delta) => {
    const cur = parseInt(filters.bathrooms, 10) || 0;
    const next = Math.min(20, Math.max(0, cur + delta));
    patchFilters({ bathrooms: next === 0 && delta < 0 ? "" : String(next) });
  };

  const handleBathroomInput = (e) => {
    const v = e.target.value;
    if (v === "") return patchFilters({ bathrooms: "" });
    const n = parseInt(v, 10);
    if (!Number.isNaN(n) && n >= 0 && n <= 20) patchFilters({ bathrooms: String(n) });
  };

  const handleReset = () => {
    setFilters(INITIAL_FILTERS);
    setPage(1);
    setOpenDropdown(null);
  };

  const goToPage = useCallback(
    (n) => {
      if (n >= 1 && n <= totalPages) {
        setPage(n);
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    },
    [totalPages],
  );

  // ---------- Location bar ----------
  const addLocation = useCallback(
    (name) => {
      const trimmed = name.trim();
      if (!trimmed) return;
      if (selectedLocations.includes(trimmed)) {
        setLocationInput("");
        return;
      }
      if (selectedLocations.length >= MAX_LOCATIONS) {
        toast.error(`You can select a maximum of ${MAX_LOCATIONS} locations.`);
        return;
      }
      setSearchCity([...selectedLocations, trimmed].join(", "));
      setPage(1);
      setLocationInput("");
    },
    [selectedLocations, setSearchCity],
  );
  addLocationRef.current = addLocation;

  const removeLocation = (loc) => {
    setSearchCity(selectedLocations.filter((l) => l !== loc).join(", "));
    setPage(1);
  };

  const handleLocationKeyDown = (e) => {
    if (e.key === "Enter" && locationInput.trim()) {
      e.preventDefault();
      addLocation(locationInput);
    }
  };

  useEffect(() => {
    if (!canAddLocation) return;
    let cancelled = false;
    let ac = null;
    loadGoogleMaps()
      .then(() => {
        if (cancelled || !locationInputRef.current) return;
        ac = new window.google.maps.places.Autocomplete(locationInputRef.current, {
          types: ["(cities)"],
          componentRestrictions: { country: "in" },
        });
        ac.addListener("place_changed", () => {
          const place = ac.getPlace();
          if (place?.name) addLocationRef.current(place.name);
        });
      })
      .catch(() => {});
    return () => {
      cancelled = true;
      if (ac) window.google.maps.event.clearInstanceListeners(ac);
    };
  }, [canAddLocation]);

  // ---------- Favourites / counts / contact ----------
  const refresh = useCallback(() => setReloadKey((k) => k + 1), []);

  const requireLogin = useCallback(() => {
    if (accessToken) return true;
    setAuthModal("login");
    return false;
  }, [accessToken]);

  const toggleFavorite = useCallback(
    async (p) => {
      if (!requireLogin()) return;
      try {
        if (p.is_favorite) {
          const fd = new FormData();
          fd.append("favorite_id", p.favorite_id);
          await axios.delete(`${API}/cust_api/remove_from_favorite`, { data: fd });
          toast.success("Removed from favourites");
        } else {
          await axios.post(`${API}/cust_api/add_to_favorite`, {
            user_id: accessToken,
            property_id: p._id,
          });
          toast.success("Saved to favourites");
        }
        refresh();
      } catch {
        toast.error("Could not update favourites. Please try again.");
      }
    },
    [accessToken, requireLogin, refresh],
  );

  const refreshCounts = useCallback(async () => {
    if (!accessToken) return;
    try {
      const fd = new FormData();
      fd.append("user_id", accessToken);
      const res = await axios.post(`${API}/cust_api/get_profile`, fd);
      const c = res.data?.count_data;
      if (c) setCounts({ free: c.free_view_count || 0, paid: c.paid_view_count || 0 });
    } catch (err) {
      console.error("Error checking post limits:", err);
    }
  }, [accessToken]);

  useEffect(() => {
    refreshCounts();
  }, [refreshCounts]);

  const handleContactClick = useCallback(
    async (property) => {
      if (!requireLogin()) return;
      const hasCredits = counts.free > 0 || counts.paid > 0;
      if (hasCredits) {
        try {
          const fd = new FormData();
          if (counts.free > 0) fd.append("free_view_count", -1);
          else fd.append("paid_view_count", -1);
          fd.append("user_id", accessToken);
          await axios.post(`${API}/cust_api/add_count`, fd);
          refreshCounts();
        } catch (err) {
          console.error("API error:", err);
        }
      }
      setContact({ open: true, property, upgrade: !hasCredits });
    },
    [accessToken, counts, requireLogin, refreshCounts],
  );

  // ---------- Share ----------
  const openShare = useCallback(
    (p) => setShare({ open: true, url: `${window.location.origin}/propertydetails/${p._id}` }),
    [],
  );
  const closeShare = useCallback(() => setShare((s) => ({ ...s, open: false })), []);
  const copyShare = useCallback(async () => {
    if (navigator.clipboard && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(share.url);
        toast.success("Link copied!");
        return;
      } catch {
        // fall through to the textarea copy
      }
    }
    fallbackCopy(share.url);
  }, [share.url]);

  // ---------- Save search ----------
  const handleSaveSearch = async () => {
    if (!accessToken) {
      toast.error("Please login first to save search.");
      setAuthModal("login");
      return;
    }
    try {
      const fd = new FormData();
      fd.append("user_id", accessToken);
      fd.append("property_id", items.map((p) => p._id || "").join("|"));
      fd.append("property_name", items.map((p) => p.property_name || "").join("|"));
      fd.append("property_category_type", items.map((p) => p.property_category_type || "").join("|"));
      fd.append("building_type", items.map((p) => p.building_type || "").join("|"));
      fd.append("city_name", cities || cityFromSession || "");
      fd.append("search_keyword", cities);
      appendFilterParams(fd, filters, {
        userType: filters.postedBy,
        bathroomKey: "no_of_bathrooms",
      });

      const res = await fetch(`${API}/cust_api/add_save_search_property`, {
        method: "POST",
        body: fd,
      });
      const result = await res.json();
      if (res.ok && result.status === 1) toast.success("Search saved successfully!");
      else toast.error(result.message || "Failed to save search.");
    } catch (err) {
      console.error("Save Search Error:", err);
      toast.error("Something went wrong.");
    }
  };

  // ---------- Card / map hover ----------
  const handleCardEnter = useCallback((p) => {
    setHoveredId(p._id);
    const lat = parseFloat(p.latitude);
    const lng = parseFloat(p.longitude);
    if (Number.isFinite(lat) && Number.isFinite(lng)) setPanTarget({ lat, lng });
  }, []);
  const handleCardLeave = useCallback(() => setHoveredId(null), []);
  const handleMarkerHover = useCallback((id) => setHoveredId(id), []);

  // ============================================================
  // RENDER
  // ============================================================

  return (
    <>
      <style>{STYLE_TEXT}</style>

      {/* ===================== LOCATION BAR ===================== */}
     

      {/* ===================== FILTERS ===================== */}
      <div
        ref={filterBarRef}
        className="bg-white rounded-xl border border-gray-200 shadow-sm relative z-20 mb-4 mx-4 sm:mx-6"
      >
        <div className="p-2">
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-1.5">
            <select
              value={filters.propertyCategory}
              onChange={(e) => handleCategoryChange(e.target.value)}
              onFocus={closeDropdown}
              className={selectCls}
              aria-label="Property category"
            >
              <option value="">Property Category</option>
              {CATEGORY_OPTIONS.map((o) => (
                <option key={o.value} value={o.value}>
                  {o.label}
                </option>
              ))}
            </select>

            <select
              value={filters.buildingType}
              onChange={(e) => patchFilters({ buildingType: e.target.value })}
              onFocus={closeDropdown}
              disabled={isCB || isCL}
              className={selectCls}
              aria-label="Building type"
            >
              <option value="">Building Type</option>
              {BUILDING_OPTIONS.map((b) => (
                <option key={b} value={b}>
                  {b}
                </option>
              ))}
            </select>

            <MultiDropdown
              id="propertyType"
              label="Property Type"
              options={propertyTypeOptions}
              selected={filters.propertyTypes}
              onToggle={togglePropertyType}
              onClear={() => clearList("propertyTypes")}
              openId={openDropdown}
              setOpenId={setOpenDropdown}
              radio={isCL}
            />

            <div className="relative">
              <button type="button" onClick={() => toggleOpen("budget")} className={btnCls}>
                <span className="truncate text-gray-700">{budgetLabel(filters)}</span>
                <RiArrowDropDownLine className="text-lg text-gray-500" />
              </button>
              {openDropdown === "budget" && (
                <div className={`${panelCls} p-3 space-y-2`}>
                  <div>
                    <label className={labelCls}>Min Price</label>
                    <select
                      value={filters.minPrice}
                      onChange={(e) => patchFilters({ minPrice: e.target.value })}
                      className={panelSelectCls}
                    >
                      <option value="">Min</option>
                      {PRICE_OPTIONS.filter((p) => !filters.maxPrice || p < Number(filters.maxPrice)).map((p) => (
                        <option key={p} value={p}>
                          {formatPriceMinMax(p)}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label className={labelCls}>Max Price</label>
                    <select
                      value={filters.maxPrice}
                      onChange={(e) => patchFilters({ maxPrice: e.target.value })}
                      className={panelSelectCls}
                    >
                      <option value="">Max</option>
                      {PRICE_OPTIONS.filter((p) => !filters.minPrice || p > Number(filters.minPrice)).map((p) => (
                        <option key={p} value={p}>
                          {formatPriceMinMax(p)}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              )}
            </div>

            <select
              value={filters.bhkType}
              onChange={(e) => patchFilters({ bhkType: e.target.value })}
              onFocus={closeDropdown}
              className={selectCls}
              aria-label="BHK"
            >
              <option value="">BHK</option>
              {BHK_OPTIONS.map((b) => (
                <option key={b} value={b}>
                  {b}
                </option>
              ))}
            </select>

            <div>
              <button
                type="button"
                onClick={() => {
                  setShowMoreFilters((v) => !v);
                  closeDropdown();
                }}
                aria-expanded={showMoreFilters}
                className={`flex items-center justify-center gap-1 w-full h-8 px-2 text-xs font-medium rounded-lg border transition-all ${
                  showMoreFilters
                    ? "bg-[#8B1E3F] text-white border-[#8B1E3F]"
                    : "bg-white text-gray-700 border-gray-300 hover:border-[#8B1E3F] hover:text-[#8B1E3F]"
                }`}
              >
                <span>More Filters</span>
                <RiArrowDropDownLine
                  className={`text-lg transition-transform ${showMoreFilters ? "rotate-180" : ""}`}
                />
              </button>
            </div>

            <div className="flex items-center gap-1.5">
              <button
                type="button"
                onClick={handleReset}
                className="h-8 flex-1 px-2 text-xs font-medium text-[#8B1E3F] border border-[#8B1E3F] rounded-lg hover:bg-[#8B1E3F]/5 transition-colors"
              >
                Reset
              </button>
              <button
                type="button"
                onClick={handleSaveSearch}
                className="h-8 flex-1 px-2 text-xs font-medium text-white bg-[#8B1E3F] rounded-lg hover:bg-[#7a1a37] transition-colors"
              >
                Save
              </button>
            </div>
          </div>
        </div>

        {showMoreFilters && (
          <div className="border-t border-gray-200 bg-gray-50/70 p-3">
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-2.5">
              <select
                value={filters.furnishedStatus}
                onChange={(e) => patchFilters({ furnishedStatus: e.target.value })}
                onFocus={closeDropdown}
                className={selectCls}
                aria-label="Furnished"
              >
                <option value="">Furnished</option>
                {FURNISHED_OPTIONS.map((o) => (
                  <option key={o} value={o}>
                    {o}
                  </option>
                ))}
              </select>

              <select
                value={filters.postedBy}
                onChange={(e) => patchFilters({ postedBy: e.target.value })}
                onFocus={closeDropdown}
                className={selectCls}
                aria-label="Posted by"
              >
                <option value="">Posted By</option>
                {POSTED_BY_OPTIONS.map((o) => (
                  <option key={o} value={o}>
                    {o}
                  </option>
                ))}
              </select>

              <MultiDropdown
                id="construction"
                label="Construction"
                options={CONSTRUCTION_OPTS}
                selected={filters.constructionStatus}
                onToggle={(v) => toggleList("constructionStatus", v)}
                onClear={() => clearList("constructionStatus")}
                openId={openDropdown}
                setOpenId={setOpenDropdown}
              />

              <MultiDropdown
                id="amenities"
                label="Amenities"
                options={amenityOptions}
                selected={filters.amenities}
                onToggle={(v) => toggleList("amenities", v)}
                onClear={() => clearList("amenities")}
                openId={openDropdown}
                setOpenId={setOpenDropdown}
              />

              <div className="flex items-center h-8 border border-gray-300 rounded-lg overflow-hidden bg-white hover:border-[#8B1E3F] transition-colors">
                <button
                  type="button"
                  onClick={() => stepBathrooms(-1)}
                  aria-label="Decrease bathrooms"
                  className="w-8 h-full flex items-center justify-center border-r hover:bg-gray-50 text-base"
                >
                  −
                </button>
                <input
                  type="number"
                  min="0"
                  max="20"
                  value={filters.bathrooms}
                  onChange={handleBathroomInput}
                  onFocus={closeDropdown}
                  placeholder="Bath"
                  className="w-full h-full text-center text-xs focus:outline-none"
                />
                <button
                  type="button"
                  onClick={() => stepBathrooms(1)}
                  aria-label="Increase bathrooms"
                  className="w-8 h-full flex items-center justify-center border-l hover:bg-gray-50 text-base"
                >
                  +
                </button>
              </div>

              {showFacing && (
                <select
                  value={filters.facing}
                  onChange={(e) => patchFilters({ facing: e.target.value })}
                  onFocus={closeDropdown}
                  className={selectCls}
                  aria-label="Facing"
                >
                  <option value="">Facing</option>
                  {FACING_OPTIONS.map((f) => (
                    <option key={f} value={f}>
                      {f}
                    </option>
                  ))}
                </select>
              )}

              <select
                value={filters.withPhoto}
                onChange={(e) => patchFilters({ withPhoto: e.target.value })}
                onFocus={closeDropdown}
                className={selectCls}
                aria-label="With photo"
              >
                <option value="">With Photo</option>
                {YES_NO.map((o) => (
                  <option key={o} value={o}>
                    {o}
                  </option>
                ))}
              </select>

              <select
                value={filters.withVideos}
                onChange={(e) => patchFilters({ withVideos: e.target.value })}
                onFocus={closeDropdown}
                className={selectCls}
                aria-label="With video"
              >
                <option value="">With Video</option>
                {YES_NO.map((o) => (
                  <option key={o} value={o}>
                    {o}
                  </option>
                ))}
              </select>

              <div className="relative">
                <button type="button" onClick={() => toggleOpen("area")} className={btnCls}>
                  <span className="truncate text-gray-700">{areaLabel(filters)}</span>
                  <RiArrowDropDownLine className="text-lg text-gray-500" />
                </button>
                {openDropdown === "area" && (
                  <div className={`${panelCls} p-3 space-y-2`}>
                    <select
                      value={filters.areaIn}
                      onChange={(e) => patchFilters({ areaIn: e.target.value })}
                      className="w-full p-2 text-xs border border-gray-300 rounded-md"
                      aria-label="Area unit"
                    >
                      {AREA_UNITS.map((u) => (
                        <option key={u} value={u}>
                          {u}
                        </option>
                      ))}
                    </select>
                    <input
                      type="number"
                      value={filters.minArea}
                      onChange={(e) => patchFilters({ minArea: e.target.value })}
                      placeholder="Min Area"
                      className="w-full p-2 text-xs border border-gray-300 rounded-md"
                    />
                    <input
                      type="number"
                      value={filters.maxArea}
                      onChange={(e) => patchFilters({ maxArea: e.target.value })}
                      placeholder="Max Area"
                      className="w-full p-2 text-xs border border-gray-300 rounded-md"
                    />
                    <button
                      type="button"
                      onClick={closeDropdown}
                      className="w-full py-1.5 text-xs text-white bg-[#8B1E3F] rounded-md hover:bg-[#7a1a37]"
                    >
                      Done
                    </button>
                  </div>
                )}
              </div>

              {isRent && (
                <MultiDropdown
                  id="availableFrom"
                  label="Available From"
                  options={AVAILABLE_FROM_OPTS}
                  selected={filters.availableFrom}
                  onToggle={(v) => toggleList("availableFrom", v)}
                  onClear={() => clearList("availableFrom")}
                  openId={openDropdown}
                  setOpenId={setOpenDropdown}
                />
              )}

              {(isRent || isPG) && (
                <MultiDropdown
                  id="availableFor"
                  label="Available For"
                  options={availableForOptions}
                  selected={filters.availableFor}
                  onToggle={(v) => toggleList("availableFor", v)}
                  onClear={() => clearList("availableFor")}
                  openId={openDropdown}
                  setOpenId={setOpenDropdown}
                />
              )}

              {isPG && (
                <MultiDropdown
                  id="sharingType"
                  label="Sharing Type"
                  options={SHARING_OPTS}
                  selected={filters.sharingType}
                  onToggle={(v) => toggleList("sharingType", v)}
                  onClear={() => clearList("sharingType")}
                  openId={openDropdown}
                  setOpenId={setOpenDropdown}
                />
              )}

              {isPG && (
                <MultiDropdown
                  id="capacity"
                  label="Total Capacity"
                  options={CAPACITY_OPTS}
                  selected={filters.capacity}
                  onToggle={(v) => toggleList("capacity", v)}
                  onClear={() => clearList("capacity")}
                  openId={openDropdown}
                  setOpenId={setOpenDropdown}
                />
              )}

              {isCB && (
                <MultiDropdown
                  id="investment"
                  label="Investment Options"
                  options={INVESTMENT_OPTS}
                  selected={filters.investmentOptions}
                  onToggle={(v) => toggleList("investmentOptions", v)}
                  onClear={() => clearList("investmentOptions")}
                  openId={openDropdown}
                  setOpenId={setOpenDropdown}
                />
              )}

              {isCB && (
                <select
                  value={filters.purchaseType}
                  onChange={(e) => patchFilters({ purchaseType: e.target.value })}
                  onFocus={closeDropdown}
                  className={selectCls}
                  aria-label="Purchase type"
                >
                  <option value="">Purchase Type</option>
                  {PURCHASE_TYPES.map((o) => (
                    <option key={o} value={o}>
                      {o}
                    </option>
                  ))}
                </select>
              )}

              {showPlotLand && (
                <MultiDropdown
                  id="plotLand"
                  label="Plot/Land Type"
                  options={PLOT_LAND_OPTS}
                  selected={filters.plotLandTypes}
                  onToggle={(v) => toggleList("plotLandTypes", v)}
                  onClear={() => clearList("plotLandTypes")}
                  openId={openDropdown}
                  setOpenId={setOpenDropdown}
                />
              )}

              {isCL && filters.propertyTypes.includes("Office Space") && (
                <MultiDropdown
                  id="officeType"
                  label="Office Type"
                  options={OFFICE_OPTS}
                  selected={filters.officeType}
                  onToggle={(v) => toggleList("officeType", v)}
                  onClear={() => clearList("officeType")}
                  openId={openDropdown}
                  setOpenId={setOpenDropdown}
                />
              )}

              {isCL && filters.propertyTypes.includes("Retail Shops/Showrooms") && (
                <MultiDropdown
                  id="retailType"
                  label="Retail Type"
                  options={RETAIL_OPTS}
                  selected={filters.retailType}
                  onToggle={(v) => toggleList("retailType", v)}
                  onClear={() => clearList("retailType")}
                  openId={openDropdown}
                  setOpenId={setOpenDropdown}
                />
              )}

              {isCL && filters.propertyTypes.includes("Other Commercial spaces") && (
                <MultiDropdown
                  id="otherCommercial"
                  label="Other Commercial Type"
                  options={OTHER_COMMERCIAL_OPTS}
                  selected={filters.otherCommercialType}
                  onToggle={(v) => toggleList("otherCommercialType", v)}
                  onClear={() => clearList("otherCommercialType")}
                  openId={openDropdown}
                  setOpenId={setOpenDropdown}
                />
              )}
            </div>
          </div>
        )}
      </div>

      {/* ===================== LISTING + MAP ===================== */}
      <div className="flex flex-col p-2 sm:p-5 space-y-4 rounded-2xl bg-[#fbf3ec] mx-4 sm:mx-6 mb-6">
        <div className="flex flex-col bg-white border border-[#eadfd6] shadow-sm rounded-2xl sm:flex-row-reverse relative">
          {/* List */}
          <div className="z-10 flex-1 min-w-0 p-3 sm:p-5">
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              {loading ? (
                Array.from({ length: 4 }, (_, i) => <Skeleton key={i} />)
              ) : visible.length > 0 ? (
                visible.map((p) => (
                  <PropertyCard
                    key={p._id}
                    property={p}
                    isHovered={hoveredId === p._id}
                    onEnter={handleCardEnter}
                    onLeave={handleCardLeave}
                    onFavorite={toggleFavorite}
                    onShare={openShare}
                    onContact={handleContactClick}
                  />
                ))
              ) : (
                <div className="py-10 text-center text-gray-700 col-span-full">
                  <p className="m-0">{error || "No properties available at the moment."}</p>
                </div>
              )}
            </div>

            {totalPages > 1 && (
              <div className="flex items-center justify-center gap-2 mt-8">
                <button
                  type="button"
                  onClick={() => goToPage(page - 1)}
                  disabled={page === 1}
                  aria-label="Previous page"
                  className={`w-9 h-9 flex items-center justify-center rounded-lg border border-[#eadfd6] bg-white text-[#7a1235] transition-colors hover:bg-[#fbf3ec] ${
                    page === 1 ? "opacity-40 cursor-not-allowed" : ""
                  }`}
                >
                  <MdOutlineNavigateBefore className="text-xl" />
                </button>
                {getPaginationRange(page, totalPages).map((n, i) => (
                  <button
                    key={`${n}-${i}`}
                    type="button"
                    onClick={() => n !== "..." && goToPage(n)}
                    className={`min-w-[36px] h-9 px-2 text-sm rounded-lg flex items-center justify-center transition-colors ${
                      page === n ? "bg-[#7a1235] text-white font-semibold" : "text-gray-700 hover:bg-[#fbf3ec]"
                    }`}
                  >
                    {n}
                  </button>
                ))}
                <button
                  type="button"
                  onClick={() => goToPage(page + 1)}
                  disabled={page === totalPages}
                  aria-label="Next page"
                  className={`w-9 h-9 flex items-center justify-center rounded-lg border border-[#eadfd6] bg-white text-[#7a1235] transition-colors hover:bg-[#fbf3ec] ${
                    page === totalPages ? "opacity-40 cursor-not-allowed" : ""
                  }`}
                >
                  <MdOutlineNavigateNext className="text-xl" />
                </button>
              </div>
            )}
          </div>

          {/* Map */}
          <div className="w-full p-3 h-[300px] sm:h-[calc(100vh-2rem)] sm:w-3/4 md:w-1/2 lg:w-[500px] sm:sticky sm:top-4 sm:self-start">
            <div className="relative w-full h-full overflow-hidden bg-[#fbf3ec] border border-[#eadfd6] rounded-xl zb-map">
              {loading ? (
                <div className="flex items-center justify-center w-full h-full gap-3 text-[#7a1235]">
                  <span className="w-5 h-5 border-2 rounded-full border-[#7a1235] border-t-transparent animate-spin" />
                  <p className="m-0 text-sm font-medium">Loading properties...</p>
                </div>
              ) : (
                <>
                  <div className="absolute z-[1000] px-3 py-1.5 text-xs font-semibold text-white rounded-lg shadow-md pointer-events-none bottom-3 left-3 bg-[#7a1235]">
                    {visible.length} properties on map
                  </div>
                  <MapContainer
                    center={mapCenter}
                    zoom={12}
                    scrollWheelZoom={false}
                    style={{ width: "100%", height: "100%" }}
                  >
                    <TileLayer url={TILE_URL} />
                    <MapPanner target={panTarget} />
                    {visible.map((p) => (
                      <PropertyMarker
                        key={p._id}
                        property={p}
                        isActive={hoveredId === p._id}
                        onHover={handleMarkerHover}
                        onLeave={handleCardLeave}
                        onFavorite={toggleFavorite}
                      />
                    ))}
                  </MapContainer>
                </>
              )}
            </div>
          </div>

          {share.open && (
            <div className="absolute right-0 z-50">
              <ShareModal currentShareUrl={share.url} closeShareModal={closeShare} copyLink={copyShare} />
            </div>
          )}
        </div>

        {contact.open && contact.property && (
          <ContactDetails
            fullName={
              counts.free <= 0 && counts.paid <= 0
                ? `****${contact.property.connect_to_name?.slice(-1) || "N/A"}`
                : contact.property.connect_to_name || "N/A"
            }
            mobile={
              counts.free <= 0 && counts.paid <= 0
                ? `*******${contact.property.connect_to_no?.slice(-3) || "000"}`
                : contact.property.connect_to_no || "N/A"
            }
            showUpgradePrompt={contact.upgrade}
            onClose={() => setContact((c) => ({ ...c, open: false }))}
          />
        )}

        <Login1
          isOpen={authModal === "login"}
          onClose={() => setAuthModal(null)}
          onSwitchToSignUp={() => setAuthModal("signup")}
        />
        <SignUp1
          isOpen={authModal === "signup"}
          onClose={() => setAuthModal(null)}
          onSwitchToLogin={() => setAuthModal("login")}
        />
      </div>
    </>
  );
};

export default FeaturedDashboard;